<template>
    <div class="mx-0 px-0 py-0 mt-3">
        <v-row no-gutters class="mx-4">
            <v-col cols="12" class="nomina-col">
                <div class="nomina-table-wrapper">
                    <v-data-table
                        ref="nominaMainTable"
                        :headers="headers"
                        :items="filteredData"
                        class="elevation-2 mt-6 nomina-main-table"
                        :mobile-breakpoint="0"
                        :loading="loading"
                        single-expand
                        :expanded.sync="expanded"
                        item-key="rowKey"
                        show-expand
                        :items-per-page="-1"
                        style="background-color: #eeeeee"
                        :style="{ 'background-color': '#eeeeee' }"
                        hide-default-footer
                    >
                        <!-- Barra superior y encabezados juntos en el mismo scroll -->
                        <template v-slot:top>
                            <v-row
                                no-gutter
                                class="pa-0 ma-0"
                                :style="{ 'background-color': '#eeeeee' }"
                            >
                                <v-col cols="12" class="d-flex">
                                    <p
                                        class="text-h5 my-0 pl-3 font-weight-bold mr-4 mt-1"
                                    >
                                        PAYROLL
                                    </p>
                                    <v-btn-toggle
                                        mandatory
                                        borderless
                                        style="height: 36px;"
                                        class="mr-4 my-0"
                                    >
                                        <v-btn
                                            @click="filter = 'weekly'"
                                            style="font-size: 12px; height: 36px;"
                                            class="px-xs-1 px-sm-1 px-md-3 px-lg-3 px-xl-3 py-1"
                                        >
                                            Weekly
                                        </v-btn>
                                        <v-btn
                                            @click="filter = 'monthly'"
                                            style="font-size: 12px; height: 36px;"
                                            class="px-xs-1 px-sm-1 px-md-3 px-lg-3 px-xl-3 py-1"
                                        >
                                            Monthly
                                        </v-btn>
                                    </v-btn-toggle>
                                    <v-spacer />
                                    <v-btn
                                        v-if="
                                            user?.permissions?.includes(
                                                'payrollManager'
                                            )
                                        "
                                        color="primary"
                                        @click="saveReportXLSX"
                                        class="d-flex align-center mr-4 mt-2"
                                        rounded
                                        :disabled="loading"
                                    >
                                        INFORM
                                        <v-icon class="ml-1"
                                            >mdi-download</v-icon
                                        >
                                    </v-btn>
                                    <v-select
                                        v-if="
                                            filter == 'weekly' ||
                                                filter == 'monthly'
                                        "
                                        class="mt-4 mr-4"
                                        dense
                                        v-model="yearFilter"
                                        :items="availableYears"
                                        label="Year"
                                        style="width: 100px; max-width: 100px;"
                                        :menu-props="{
                                            bottom: true,
                                            offsetY: true,
                                            auto: true,
                                        }"
                                    ></v-select>
                                    <v-select
                                        v-if="filter == 'weekly'"
                                        class="mt-4 mr-4"
                                        dense
                                        v-model="weekFilter"
                                        :items="availableWeeks"
                                        label="Select Week"
                                        style="width: 150px; max-width: 150px;"
                                        :menu-props="{
                                            bottom: true,
                                            offsetY: true,
                                            auto: true,
                                        }"
                                    ></v-select>
                                    <v-select
                                        v-if="filter == 'monthly'"
                                        class="mt-4 mr-4"
                                        dense
                                        v-model="monthFilter"
                                        :items="availableMonths"
                                        label="Select Month"
                                        style="width: 150px; max-width: 150px;"
                                        :menu-props="{
                                            bottom: true,
                                            offsetY: true,
                                            auto: true,
                                        }"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:[`item.workflowStatus`]="{ item }">
                            <v-chip
                                small
                                :color="
                                    getWorkflowStatusColor(
                                        getWorkflowStatus(item)
                                    )
                                "
                                text-color="white"
                                class="my-1"
                            >
                                {{
                                    getWorkflowStatusLabel(
                                        getWorkflowStatus(item)
                                    )
                                }}
                            </v-chip>
                        </template>
                        <template v-slot:[`item.totalHours`]="{ item }">
                            <div class="d-flex justify-start align-end">
                                <p class="my-0">
                                    {{
                                        (hours =>
                                            hours != 0.0 ? `${hours} h` : '-')(
                                            getTotalHours(item)
                                        )
                                    }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.overtimeHours`]="{ item }">
                            <div class="d-flex justify-start align-end">
                                <p class="my-0">
                                    {{
                                        (hours =>
                                            hours != 0.0 ? `${hours} h` : '-')(
                                            getOvertimeHours(item)
                                        )
                                    }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.price`]="{ item }">
                            <div class="d-flex justify-start align-end">
                                <p class="my-0">
                                    {{
                                        (price =>
                                            price !== '-'
                                                ? `$ ${price}`
                                                : price)(setHourlyPrice(item))
                                    }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.overtimePrice`]="{ item }">
                            <div class="d-flex justify-start align-end">
                                <p class="my-0">
                                    {{
                                        (price =>
                                            price !== '-'
                                                ? `$ ${price}`
                                                : price)(setOvertimePrice(item))
                                    }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.otherCosts`]="{ item }">
                            <div class="d-flex justify-start align-end">
                                <p class="my-0">
                                    {{
                                        (otherCosts =>
                                            otherCosts !== '-'
                                                ? `$ ${otherCosts}`
                                                : otherCosts)(
                                            setOtherCosts(item)
                                        )
                                    }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.total`]="{ item }">
                            <div class="d-flex justify-start align-end">
                                <p class="my-0">
                                    {{
                                        (total =>
                                            total !== '-'
                                                ? `$ ${total}`
                                                : total)(setTotal(item))
                                    }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <div>
                                <v-tooltip
                                    v-if="
                                        getStatus(item) == 'Pending' &&
                                            userType !== 'payrollManager'
                                    "
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openAlertPayroll(item)"
                                        >
                                            <v-icon
                                                >mdi-timer-stop-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Close Payroll</span>
                                </v-tooltip>
                                <v-tooltip
                                    v-if="
                                        getStatus(item) == 'Payroll' &&
                                            userType == 'payrollManager'
                                    "
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openReportDialog(item)"
                                        >
                                            <v-icon
                                                >mdi-clipboard-edit-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Generate Report</span>
                                </v-tooltip>
                                <v-tooltip
                                    v-if="getStatus(item) == 'Processed'"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openReport(item)"
                                        >
                                            <v-icon>mdi-eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>View Report</span>
                                </v-tooltip>
                            </div>
                        </template>
                        <template
                            v-slot:expanded-item="{ headers, item: timesheet }"
                        >
                            <td
                                :colspan="headers.length"
                                class="py-4 ma-0 pl-10 pr-10 outlined nomina-expanded-row-content"
                                :style="{ background: 'white' }"
                            >
                                <div
                                    class="mb-4 nomina-inner-table-wrapper"
                                    v-if="
                                        getTimesheetsForRow(
                                            timesheet,
                                            'lastExternalUsersData'
                                        ).length > 0
                                    "
                                >
                                    <v-data-table
                                        :headers="
                                            getTimesheetHeaders(timesheet)
                                        "
                                        :items="
                                            getTimesheetsForRow(
                                                timesheet,
                                                'lastExternalUsersData'
                                            )
                                        "
                                        class="ma-0 pa-0 elevation-0"
                                        :mobile-breakpoint="0"
                                        :loading="timesheetLoading"
                                        :style="{ width: 'auto' }"
                                        fixed-header
                                        hide-default-footer
                                    >
                                        <template v-slot:top>
                                            <v-row
                                                no-gutter
                                                class="pa-0 ma-0"
                                                :style="{
                                                    'background-color':
                                                        '#eeeeee',
                                                }"
                                            >
                                                <v-col cols="12" class="d-flex">
                                                    <p
                                                        class="text-h5 my-0 pl-3 font-weight-bold mr-4 mt-1"
                                                    >
                                                        {{
                                                            filter == 'weekly'
                                                                ? `Previous Week`
                                                                : `Previous Month`
                                                        }}
                                                    </p>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template
                                            v-slot:[`item.date`]="{ item }"
                                        >
                                            <div
                                                class="d-flex justify-start align-end"
                                            >
                                                <p class="my-0">
                                                    {{
                                                        filter == 'weekly'
                                                            ? item.date
                                                                ? getDayOfWeek(
                                                                      item.date
                                                                  )
                                                                : ''
                                                            : item.date
                                                            ? getDayOfWeek(
                                                                  item.date
                                                              ) +
                                                              '/' +
                                                              item.date.split(
                                                                  '-'
                                                              )[2]
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>

                                        <template
                                            v-slot:[`item.scope`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.selectedCost?.cost
                                                            .reference || ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.location`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.projectLocation
                                                            ?.name
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.clockIn`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.clockIn
                                                            ? formatTime(
                                                                  item.clockIn
                                                              )
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.clockOut`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.clockOut
                                                            ? formatTime(
                                                                  item.clockOut
                                                              )
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.totalTime`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.clockIn &&
                                                        item.clockOut
                                                            ? (
                                                                  (item.clockOut
                                                                      ._seconds -
                                                                      item
                                                                          .clockIn
                                                                          ._seconds) /
                                                                  3600
                                                              ).toFixed(2) +
                                                              ' hours'
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.status`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        getStatusTimeSheets(
                                                            item
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.actions`]="{ item }"
                                        >
                                            <div>
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :disabled="
                                                                userType ===
                                                                    'payrollManager' ||
                                                                    getStatusTimeSheets(
                                                                        item
                                                                    ) ===
                                                                        'Closed'
                                                            "
                                                            @click="
                                                                openEditRecordDialog(
                                                                    item
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-pencil</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :disabled="
                                                                userType ===
                                                                    'payrollManager' ||
                                                                    getStatusTimeSheets(
                                                                        item
                                                                    ) ===
                                                                        'Closed'
                                                            "
                                                            @click="
                                                                openDeleteRecordDialog(
                                                                    item
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </div>
                                <div class="mb-4">
                                    <v-data-table
                                        :headers="
                                            getTimesheetHeaders(timesheet)
                                        "
                                        :items="
                                            getTimesheetsForRow(
                                                timesheet,
                                                'externalUsersData'
                                            )
                                        "
                                        class="ma-0 pa-0 elevation-0"
                                        :mobile-breakpoint="0"
                                        :loading="timesheetLoading"
                                        :style="{ width: 'auto' }"
                                        fixed-header
                                        hide-default-footer
                                    >
                                        <template v-slot:top>
                                            <v-row
                                                no-gutter
                                                class="pa-0 ma-0"
                                                :style="{
                                                    'background-color':
                                                        '#eeeeee',
                                                }"
                                            >
                                                <v-col cols="12" class="d-flex">
                                                    <p
                                                        class="text-h5 my-0 pl-3 font-weight-bold mr-4 mt-1"
                                                    >
                                                        {{
                                                            filter == 'weekly'
                                                                ? `Week ${weekFilter} Report`
                                                                : `${monthFilter} Report`
                                                        }}
                                                    </p>
                                                    <v-spacer />
                                                    <v-tooltip
                                                        bottom
                                                        v-if="
                                                            userType ==
                                                                'superintendent' &&
                                                                getStatus(
                                                                    timesheet
                                                                ) == 'Pending'
                                                        "
                                                    >
                                                        <template
                                                            v-slot:activator="{
                                                                on,
                                                                attrs,
                                                            }"
                                                        >
                                                            <v-btn
                                                                small
                                                                icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                @click="
                                                                    createTimesheet(
                                                                        timesheet
                                                                    )
                                                                "
                                                            >
                                                                <v-icon
                                                                    >mdi-plus</v-icon
                                                                >
                                                            </v-btn>
                                                        </template>
                                                        <span
                                                            >Create
                                                            Timesheet</span
                                                        >
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template
                                            v-slot:[`item.date`]="{ item }"
                                        >
                                            <div
                                                class="d-flex justify-start align-end"
                                            >
                                                <p class="my-0">
                                                    {{
                                                        filter == 'weekly'
                                                            ? item.date
                                                                ? getDayOfWeek(
                                                                      item.date
                                                                  )
                                                                : ''
                                                            : item.date
                                                            ? getDayOfWeek(
                                                                  item.date
                                                              ) +
                                                              '/' +
                                                              item.date.split(
                                                                  '-'
                                                              )[2]
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>

                                        <template
                                            v-slot:[`item.scope`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.selectedCost?.cost
                                                            .reference || ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.location`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.projectLocation
                                                            ?.name
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.clockIn`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.clockIn
                                                            ? formatTime(
                                                                  item.clockIn
                                                              )
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.clockOut`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.clockOut
                                                            ? formatTime(
                                                                  item.clockOut
                                                              )
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.totalTime`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        item.clockIn &&
                                                        item.clockOut
                                                            ? (
                                                                  (item.clockOut
                                                                      ._seconds -
                                                                      item
                                                                          .clockIn
                                                                          ._seconds) /
                                                                  3600
                                                              ).toFixed(2) +
                                                              ' hours'
                                                            : ''
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.status`]="{ item }"
                                        >
                                            <div class="d-flex justify-center">
                                                <p class="my-0">
                                                    {{
                                                        getStatusTimeSheets(
                                                            item
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                        </template>
                                        <template
                                            v-slot:[`item.actions`]="{ item }"
                                        >
                                            <div>
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :disabled="
                                                                userType ===
                                                                    'payrollManager' ||
                                                                    getStatusTimeSheets(
                                                                        item
                                                                    ) ===
                                                                        'Closed'
                                                            "
                                                            @click="
                                                                openEditRecordDialog(
                                                                    item
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-pencil</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :disabled="
                                                                userType ===
                                                                    'payrollManager' ||
                                                                    getStatusTimeSheets(
                                                                        item
                                                                    ) ===
                                                                        'Closed'
                                                            "
                                                            @click="
                                                                openDeleteRecordDialog(
                                                                    item
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </div>
                            </td>
                        </template>
                    </v-data-table>
                </div>
            </v-col>
        </v-row>
        <!-- dialog delete record -->
        <v-dialog
            :retain-focus="false"
            v-model="dialogDeleteRecord"
            persistent
            max-width="400px"
        >
            <v-card>
                <v-card-title class="text-h5">Delete Record</v-card-title>
                <v-card-text>
                    Do you want to delete the record?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="closeDialogDeleteRecord()"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deleteRecord()"
                        text
                        color="error"
                        :loading="loading2"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog edit record -->
        <v-dialog
            persistent
            max-width="470px"
            v-model="dialogEditRecord"
            content-class="custom-dialog"
        >
            <v-card :loading="loading2" class="custom-dialog">
                <v-card-title class="text-h5">
                    <v-btn
                        class="mr-3"
                        depressed
                        color="primary"
                        icon
                        rounded
                        @click="closeDialogEditRecord"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    {{ 'Edit Record' }}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider class="mx-5" />
                <v-card-text>
                    <v-form
                        v-model="valid"
                        class="mx-5 mt-3"
                        :disabled="loading2"
                    >
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="recordToEdit.date"
                                    type="text"
                                    label="Date"
                                    prepend-icon="mdi-calendar-month"
                                    disabled
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0 mb-3">
                            <v-col cols="12" class="py-0">
                                <v-select
                                    v-model="scopeSelected"
                                    :items="keys"
                                    label="Select a Scope"
                                    hide-details
                                    prepend-icon="mdi-receipt-text-outline"
                                    hide-selected
                                    @change="updateValue"
                                    :menu-props="{
                                        bottom: true,
                                        offsetY: true,
                                    }"
                                    :disabled="
                                        !user?.permissions?.includes(
                                            'superintendent'
                                        )
                                    "
                                />
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <template>
                                    <v-row class="mt-2 mb-1">
                                        <v-col cols="auto">
                                            <v-icon>mdi-clock-start</v-icon>
                                        </v-col>
                                        <v-col>
                                            <vue-timepicker
                                                v-model="clockInSelected"
                                                class="custom-timepicker"
                                                format="hh:mm:ss a"
                                                input-width="100%"
                                                close-on-complete
                                                placeholder="Clock In"
                                                hide-clear-button
                                                :disabled="loading2"
                                            ></vue-timepicker>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <template>
                                    <v-row class="mt-2 mb-1">
                                        <v-col cols="auto">
                                            <v-icon>mdi-clock-end</v-icon>
                                        </v-col>
                                        <v-col>
                                            <vue-timepicker
                                                v-model="clockOutSelected"
                                                class="custom-timepicker"
                                                format="hh:mm:ss a"
                                                input-width="100%"
                                                close-on-complete
                                                placeholder="Clock Out"
                                                hide-clear-button
                                                :disabled="loading2"
                                            ></vue-timepicker>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0 mb-2">
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="hoursDiff"
                                    type="number"
                                    step="0.5"
                                    label="Total hours"
                                    min="0"
                                    hide-details
                                    :rules="[rules.halfRound]"
                                    prepend-icon="mdi-clock-outline"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="selectedNotes"
                                    type="text"
                                    label="Notes"
                                    prepend-icon="mdi-receipt-text-outline"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="otherCosts"
                                    type="number"
                                    label="Other Costs"
                                    :rules="[rules.validateNumber]"
                                    prepend-icon="mdi-currency-usd"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                    <div class="pb-1 pt-3 mt-3">
                        <v-row ref="invoice-files">
                            <v-col cols="12" class="py-0">
                                <div class="d-flex my-2">
                                    <div class="d-flex align-center pl-1">
                                        <strong>ATTACHMENTS: </strong>
                                    </div>
                                    <div
                                        class="d-flex align-center flex-wrap mt-4"
                                    >
                                        <div
                                            v-for="(file, i) in files"
                                            :key="i"
                                            class="d-flex"
                                        >
                                            <v-card
                                                class="d-flex ma-0 ml-2 pa-1 mb-4"
                                                @click="openFile(file.name)"
                                                :style="{
                                                    position: 'relative',
                                                }"
                                            >
                                                <v-img
                                                    class="mb-2 pb-2"
                                                    max-width="100px"
                                                    max-height="100px"
                                                    :src="
                                                        file.pdfPreview
                                                            ? file.pdfPreview
                                                            : file.url
                                                    "
                                                >
                                                </v-img>
                                                <div>
                                                    <v-btn
                                                        small
                                                        icon
                                                        color="red"
                                                        elevation="4"
                                                        :style="{
                                                            position:
                                                                'absolute',
                                                            top: '8px',
                                                            right: '8px',
                                                        }"
                                                    >
                                                        <v-icon
                                                            background
                                                            @click.stop="
                                                                deleteFileRecord(
                                                                    file.name
                                                                )
                                                            "
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </div>
                                            </v-card>
                                        </div>
                                        <v-btn
                                            v-if="
                                                user?.permissions?.includes(
                                                    'superintendent'
                                                ) && scopeSelected
                                            "
                                            @click="onButtonClick2"
                                            color="transparent"
                                            elevation="0"
                                            small
                                            class="text-capitalize text--darken-2 mb-4 ml-2"
                                            fab
                                        >
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                        <input
                                            ref="uploader1"
                                            class="d-none"
                                            type="file"
                                            accept="application/pdf, image/*"
                                            @change="onFileChanged2"
                                        />
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        :loading="loading2"
                        @click="editRecord"
                        :disabled="isInvalidTime"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog report -->
        <v-dialog
            persistent
            width="750px"
            max-width="800px"
            v-model="dialogReport"
            content-class="custom-dialog"
        >
            <v-card :loading="loading2" class="custom-dialog">
                <v-card-title class="text-h5">
                    <v-btn
                        class="mr-3"
                        depressed
                        color="primary"
                        icon
                        rounded
                        @click="closeDialogReport"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    {{
                        filter == 'weekly'
                            ? `Create Report: Week ${weekFilter}`
                            : `Create Report: ${monthFilter}`
                    }}
                    <v-spacer />
                    <v-btn
                        :loading="loading2"
                        color="primary"
                        text
                        @click="saveReport()"
                    >
                        SAVE
                    </v-btn>
                </v-card-title>
                <v-divider class="mx-5" />
                <v-card-text>
                    <v-col cols="12" class="mt-4">
                        <h2>DETAILS</h2>
                        <v-divider class="mt-2" />
                        <v-form
                            v-model="valid2"
                            class="mx-5 mt-3"
                            :disabled="loading2"
                        >
                            <v-row class="mt-0">
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="reportData.userName"
                                        type="text"
                                        label="Name"
                                        prepend-icon="mdi-account"
                                        readonly
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="reportData.role"
                                        type="text"
                                        label="Role"
                                        prepend-icon="mdi-card-account-details-outline"
                                        readonly
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-0">
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="reportData.email"
                                        type="text"
                                        label="email"
                                        prepend-icon="mdi-email-outline"
                                        readonly
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="reportData.phone"
                                        type="text"
                                        label="Phone"
                                        prepend-icon="mdi-phone-outline"
                                        readonly
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-0">
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                        v-model="reportData.name"
                                        type="text"
                                        label="Project"
                                        prepend-icon="mdi-text-box-outline"
                                        readonly
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-0">
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="reportData.totalHours"
                                        type="text"
                                        label="Reported Hours"
                                        prepend-icon="mdi-clock-check-outline"
                                        readonly
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="reportData.hourlyPrice"
                                        type="number"
                                        :rules="[rules.validateNumber]"
                                        label="Hourly Price"
                                        prepend-icon="mdi-currency-usd"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-0">
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="reportData.overtimeHours"
                                        type="text"
                                        label="Overtime Hours"
                                        prepend-icon="mdi-clock-check-outline"
                                        readonly
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        v-model="getTotalOvertime"
                                        type="number"
                                        label="total Overtime"
                                        prepend-icon="mdi-currency-usd"
                                        disabled
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-0">
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                        v-model="reportData.otherCosts"
                                        type="number"
                                        label="Other Costs"
                                        :rules="[rules.validateNumber]"
                                        prepend-icon="mdi-currency-usd"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-0">
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                        v-model="getTotalCosts"
                                        type="number"
                                        label="Total"
                                        prepend-icon="mdi-currency-usd"
                                        disabled
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-0">
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                        v-model="reportData.reportNotes"
                                        type="text"
                                        label="Report Notes"
                                        prepend-icon="mdi-receipt-text-outline"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                    <v-col cols="12" class="mt-4">
                        <h2>ATTACHMENTS</h2>
                        <v-divider class="mt-2" />
                        <div class="d-flex align-center flex-wrap mt-4">
                            <div
                                v-for="(file, i) in reportData.attachments"
                                :key="i"
                                class="d-flex"
                            >
                                <v-card
                                    class="d-flex ma-0 ml-2 pa-1"
                                    @click="openFileAttached(file.name)"
                                    :style="{ position: 'relative' }"
                                >
                                    <v-img
                                        class="ma-0 pa-0"
                                        max-width="100px"
                                        max-height="100px"
                                        :src="
                                            file.pdfPreview
                                                ? file.pdfPreview
                                                : file.url
                                        "
                                    >
                                    </v-img>
                                    <div>
                                        <v-btn
                                            small
                                            icon
                                            color="red"
                                            elevation="4"
                                            :style="{
                                                position: 'absolute',
                                                top: '8px',
                                                right: '8px',
                                            }"
                                        >
                                            <v-icon
                                                background
                                                @click.stop="
                                                    deleteFile(file.name)
                                                "
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </div>
                                </v-card>
                            </div>
                            <v-btn
                                @click="onButtonClick"
                                depressed
                                fab
                                x-small
                                color="primary"
                                class="ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                            >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                            <input
                                ref="uploader2"
                                class="d-none"
                                type="file"
                                accept="application/pdf, image/*"
                                @change="onFileChanged"
                            />
                        </div>
                    </v-col>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        :loading="loading2"
                        :disabled="!validForm"
                        @click="saveReport(true)"
                    >
                        GENERATE REPORT
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog close payroll -->
        <v-dialog
            :retain-focus="false"
            v-model="closePayrollDialog"
            persistent
            max-width="400px"
        >
            <v-card>
                <v-card-title class="text-h5">Close Payroll</v-card-title>
                <v-card-text>
                    Do you want to close the payroll at this moment?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeDialogPayroll()">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="closePayroll()"
                        text
                        color="error"
                        :loading="loading2"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog create timesheet -->
        <v-dialog
            persistent
            max-width="470px"
            v-model="dialogCreateTimesheet"
            content-class="custom-dialog"
        >
            <v-card :loading="loading2" class="custom-dialog">
                <v-card-title class="text-h5">
                    <v-btn
                        class="mr-3"
                        depressed
                        color="primary"
                        icon
                        rounded
                        @click="closeCreateTimesheet"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    {{ 'Create Timesheet' }}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider class="mx-5" />
                <v-card-text>
                    <v-form
                        v-model="valid3"
                        class="mx-5 mt-3"
                        :disabled="loading2"
                    >
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <v-menu
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="timesheetDate"
                                            label="Date *"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            class="pt-1 mt-4"
                                            required
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="selectedDateTimesheet"
                                        :allowed-dates="allowedDates"
                                        @input="updateDate"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0 mb-3">
                            <v-col cols="12" class="py-0">
                                <v-select
                                    v-model="scopeTimesheet"
                                    :items="scopes"
                                    label="Select a Scope *"
                                    hide-details
                                    prepend-icon="mdi-receipt-text-outline"
                                    hide-selected
                                    :rules="[rules.required]"
                                    @change="updateScope"
                                    :menu-props="{
                                        bottom: true,
                                        offsetY: true,
                                    }"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="mt-0 mb-3">
                            <v-col cols="12" class="py-0">
                                <v-select
                                    v-model="projectLocation"
                                    :items="projectLocations"
                                    label="Project Location *"
                                    hide-details
                                    prepend-icon="mdi-map-marker"
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    :rules="[rules.required]"
                                    :menu-props="{
                                        bottom: true,
                                        offsetY: true,
                                    }"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <template>
                                    <v-row class="mt-2 mb-1">
                                        <v-col cols="auto">
                                            <v-icon>mdi-clock-start</v-icon>
                                        </v-col>
                                        <v-col>
                                            <vue-timepicker
                                                v-model="clockInTimesheet"
                                                class="custom-timepicker"
                                                format="hh:mm:ss a"
                                                input-width="100%"
                                                close-on-complete
                                                placeholder="Clock In *"
                                                hide-clear-button
                                                :disabled="loading2"
                                            ></vue-timepicker>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <template>
                                    <v-row class="mt-2 mb-1">
                                        <v-col cols="auto">
                                            <v-icon>mdi-clock-end</v-icon>
                                        </v-col>
                                        <v-col>
                                            <vue-timepicker
                                                v-model="clockOutTimesheet"
                                                class="custom-timepicker"
                                                format="hh:mm:ss a"
                                                input-width="100%"
                                                close-on-complete
                                                placeholder="Clock Out *"
                                                hide-clear-button
                                                :disabled="loading2"
                                            ></vue-timepicker>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="timesheetNotes"
                                    type="text"
                                    label="Notes"
                                    prepend-icon="mdi-receipt-text-outline"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        :loading="loading2"
                        @click="saveTimesheet"
                        :disabled="isInvalidTimesheet || !valid3"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import API from '@/services/api'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import { objDiff } from '@/helpers/objDiff.js'
import { storage } from '@/services/firebase'
import { deleteFile } from '@/services/storage/deleteFile.js'
import { saveFile } from '@/services/storage/saveFile.js'
import {
    loadPDFPreview,
    generateHTMLReport,
} from '@/components/Nomina/ReportNomina.js'
import _ from 'lodash'
import { mapMutations } from 'vuex'
import moment from 'moment'
import { dataURLtoFile } from '@/helpers/base64ToFile.js'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
    name: 'nomina',
    components: { VueTimepicker },
    data: () => ({
        headers: [
            {
                text: 'Name',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Identification',
                value: 'identification',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Project',
                value: 'projectName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Status',
                value: 'workflowStatus',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Total Hours',
                value: 'totalHours',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Overtime Hours',
                value: 'overtimeHours',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Normal Price',
                value: 'price',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Overtime Price',
                value: 'overtimePrice',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Other Costs',
                value: 'otherCosts',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Total',
                value: 'total',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Notes',
                value: 'notes',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Actions',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        dialogReport: false,
        dialogCreateTimesheet: false,
        selectedDateTimesheet: null,
        timesheetDate: null,
        valid3: false,
        scopeTimesheet: null,
        scopeValueTimesheet: null,
        itemsScopesTimesheet: {},
        selectedTimesheet: {},
        valid2: false,
        menu: false,
        reportUser: {},
        reportData: {
            totalHours: 0.0,
            overtimeHours: 0.0,
            created: false,
            reportNotes: '',
            otherCosts: 0.0,
            hourlyPrice: '',
            userName: null,
            role: null,
            email: null,
            phone: null,
            name: null,
            externalUsersData: [],
            date: '',
            attachments: [],
        },
        originalReport: {},
        companyId: JSON.parse(localStorage.getItem('company')),
        rules: {
            required: v => !!v || 'Required',
            validateNumber: v => {
                const numberValue = parseFloat(v)
                return (
                    (!isNaN(numberValue) && numberValue >= 0) ||
                    'Invalid Number'
                )
            },
            halfRound: v => {
                const numberValue = parseFloat(v)
                if (isNaN(numberValue) || numberValue < 0)
                    return 'Must be a number >= 0'

                const decimal = numberValue % 1
                return (
                    decimal === 0 ||
                    decimal === 0.5 ||
                    'Must be a whole number or end in .5'
                )
            },
        },
        localAttachments: [],
        scopeSelected: null,
        scopeValue: null,
        itemsScopeSelected: {},
        clockInTimesheet: { hh: '', mm: '', ss: '', a: '' },
        clockOutTimesheet: { hh: '', mm: '', ss: '', a: '' },
        clockInSelected: { hh: '', mm: '', ss: '', a: '' },
        clockOutSelected: { hh: '', mm: '', ss: '', a: '' },
        timesheetNotes: '',
        projectLocations: [],
        projectLocation: null,
        selectedNotes: '',
        notesSelected: '',
        valid: false,
        loading: false,
        expanded: [],
        timesheetLoading: false,
        projects: [],
        users: [],
        recordToDelete: {},
        dialogDeleteRecord: false,
        loading2: false,
        filter: 'weekly',
        yearFilter: new Date().getFullYear(),
        availableWeeks: Array.from({ length: 52 }, (_, i) => i + 1),
        availableMonths: moment.months(),
        monthFilter: new Date().toLocaleString('en', { month: 'long' }),
        weekFilter: 0,
        usersList: [],
        recordToEdit: {},
        dialogEditRecord: false,
        _syncingHoursFromClocks: false,
        userId: JSON.parse(localStorage.getItem('userId')),
        closePayrollDialog: false,
        itemToClose: {},
        user: {},
        userType: '',
        deleteFiles: [],
        files: [],
        temporalAttachments: [],
        deleteAttachments: [],
        otherCosts: 0,
        hoursDiff: 0,
    }),
    computed: {
        availableYears() {
            const endYear = new Date().getFullYear()
            const startYear = 2025
            const lastYear = Math.max(endYear, startYear)
            const length = lastYear - startYear + 1
            return Array.from({ length }, (_, i) => lastYear - i)
        },
        scopes() {
            let keys = Object.keys(this.itemsScopesTimesheet)
            const setKeys = [...new Set(keys)]
            return setKeys
        },
        allowedDates() {
            return date => {
                if (this.filter === 'weekly') {
                    return this.isDateInWeek(date)
                } else if (this.filter === 'monthly') {
                    return this.isDateInMonth(date)
                }
                return true
            }
        },
        filteredData() {
            const usersList = this.usersList || []
            const year = parseInt(this.yearFilter, 10)
            const week = parseInt(this.weekFilter, 10)
            const monthStr = this.monthFilter
            const month = new Date(`${monthStr} 1, 2000`).getMonth() + 1
            if (this.filter === 'weekly' && isNaN(week)) return usersList
            if (this.filter === 'monthly' && isNaN(month)) return usersList
            const reportName =
                this.filter === 'weekly' ? `Week ${this.weekFilter}` : monthStr
            const previousReportName = this.getPreviousReportName(
                year,
                week,
                month,
                monthStr
            )
            const result = []
            let currentDates = [],
                previousDates = [],
                lastYear = year
            if (this.filter === 'weekly') {
                if (!week || week < 1) return []
                const currentStart = this.getWeekStartDate(year, week)
                currentDates = this.getWeekDates(currentStart)
                let lastWeek = week - 1
                if (week === 1) {
                    lastWeek = 52
                    lastYear = year - 1
                }
                const lastStart = this.getWeekStartDate(lastYear, lastWeek)
                previousDates = this.getWeekDates(lastStart)
            }
            if (this.filter === 'monthly') {
                const lastMonth = month === 1 ? 12 : month - 1
                const lastYearMonth = month === 1 ? year - 1 : year
                currentDates = usersList.flatMap(user =>
                    (user.externalUsersData || [])
                        .map(ts => ts.date)
                        .filter(d => {
                            const parts = this.parseDateParts(d)
                            return (
                                parts &&
                                parts.month === month &&
                                parts.year === year
                            )
                        })
                )
                previousDates = usersList.flatMap(user =>
                    (user.externalUsersData || [])
                        .map(ts => ts.date)
                        .filter(d => {
                            const parts = this.parseDateParts(d)
                            return (
                                parts &&
                                parts.month === lastMonth &&
                                parts.year === lastYearMonth
                            )
                        })
                )
            }
            for (const user of usersList) {
                const externalData = user.externalUsersData || []
                const current = this.filterTimesheetsByDates(
                    externalData,
                    currentDates,
                    user,
                    'current',
                    reportName
                )
                const previous = this.filterTimesheetsByDates(
                    externalData,
                    previousDates,
                    user,
                    'previous',
                    previousReportName
                )
                if (current.length || previous.length) {
                    result.push({
                        ...user,
                        externalUsersData: current,
                        lastExternalUsersData: previous,
                    })
                }
            }
            return result.filter(user => {
                const status = this.getStatus(user)
                if (
                    status === 'Pending' &&
                    this.userType === 'superintendent' &&
                    this.isProjectSuperApproved(
                        user,
                        reportName,
                        user.projectId
                    )
                ) {
                    return false
                }
                if (
                    status === 'Pending' &&
                    this.userType === 'PM' &&
                    this.isProjectSuperApproved(
                        user,
                        reportName,
                        user.projectId
                    )
                ) {
                    return true
                }
                if (status === 'Processed' && this.userType === 'PM') {
                    return true
                }
                if (
                    ['Pending', 'Processed'].includes(status) &&
                    this.userType === 'superintendent'
                ) {
                    return true
                }
                if (
                    this.userType === 'payrollManager' &&
                    ['Pending', 'Payroll', 'Processed'].includes(status)
                ) {
                    return true
                }
                return false
            })
        },
        isInvalidTime() {
            const defaultTime = { hh: '', mm: '', ss: '', a: '' }

            const isValidTime = time => {
                return (
                    Number.isInteger(parseInt(time.hh)) &&
                    Number.isInteger(parseInt(time.mm)) &&
                    Number.isInteger(parseInt(time.ss)) &&
                    (time.a === 'am' || time.a === 'pm')
                )
            }
            if (!isValidTime(this.clockInSelected)) {
                return true
            }
            if (
                JSON.stringify(this.clockOutSelected) ===
                JSON.stringify(defaultTime)
            ) {
                return false
            }
            if (!isValidTime(this.clockOutSelected)) {
                return true
            }
            const convertTo24Hour = ({ hh, mm, ss, a }) => {
                let hours = parseInt(hh)
                if (a === 'pm' && hours !== 12) hours += 12
                if (a === 'am' && hours === 12) hours = 0
                return hours * 3600 + parseInt(mm) * 60 + parseInt(ss)
            }
            const clockInSeconds = convertTo24Hour(this.clockInSelected)
            const clockOutSeconds = convertTo24Hour(this.clockOutSelected)
            return clockOutSeconds <= clockInSeconds
        },
        isInvalidTimesheet() {
            const defaultTime = { hh: '', mm: '', ss: '', a: '' }

            const isValidTime = time => {
                return (
                    Number.isInteger(parseInt(time.hh)) &&
                    Number.isInteger(parseInt(time.mm)) &&
                    Number.isInteger(parseInt(time.ss)) &&
                    (time.a === 'am' || time.a === 'pm')
                )
            }
            if (
                !isValidTime(this.clockInTimesheet) ||
                !isValidTime(this.clockOutTimesheet)
            ) {
                return true
            }
            if (
                JSON.stringify(this.clockOutTimesheet) ===
                JSON.stringify(defaultTime)
            ) {
                return false
            }
            if (!isValidTime(this.clockOutTimesheet)) {
                return true
            }
            const convertTo24Hour = ({ hh, mm, ss, a }) => {
                let hours = parseInt(hh)
                if (a === 'pm' && hours !== 12) hours += 12
                if (a === 'am' && hours === 12) hours = 0
                return hours * 3600 + parseInt(mm) * 60 + parseInt(ss)
            }
            const clockInSeconds = convertTo24Hour(this.clockInTimesheet)
            const clockOutSeconds = convertTo24Hour(this.clockOutTimesheet)
            return clockOutSeconds <= clockInSeconds
        },
        keys() {
            let keys = Object.keys(this.itemsScopeSelected)
            if (this.recordToEdit.selectedCost) {
                keys = [this.recordToEdit.selectedCost.cost.reference, ...keys]
            }
            const setKeys = [...new Set(keys)]
            return setKeys
        },
        getTotalCosts() {
            return (
                (parseFloat(this.reportData.totalHours) -
                    parseFloat(this.reportData.overtimeHours) || 0) *
                    (parseFloat(this.reportData.hourlyPrice) || 0) +
                (parseFloat(this.reportData.otherCosts) || 0) +
                parseFloat(this.getTotalOvertime || 0)
            ).toFixed(2)
        },
        getTotalOvertime() {
            return (
                (parseFloat(this.reportData.overtimeHours) || 0) *
                (parseFloat(this.reportData.hourlyPrice) || 0) *
                1.015
            ).toFixed(2)
        },
        validForm() {
            return this.reportData.hourlyPrice != ''
        },
    },
    watch: {
        clockInSelected: {
            handler() {
                this._syncingHoursFromClocks = true
                this.hoursDiff = this.calculateRoundedDiff()
                this.$nextTick(() => {
                    this._syncingHoursFromClocks = false
                })
            },
            deep: true,
        },
        clockOutSelected: {
            handler() {
                this._syncingHoursFromClocks = true
                this.hoursDiff = this.calculateRoundedDiff()
                this.$nextTick(() => {
                    this._syncingHoursFromClocks = false
                })
            },
            deep: true,
        },
        hoursDiff(val) {
            if (this._syncingHoursFromClocks) return
            this.updateClockOut(val)
        },
        filter() {
            // Barra y encabezados van juntos en el mismo scroll; no se necesita actualizar altura
        },
    },
    async mounted() {
        try {
            this.loading = true
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            if (user.permissions.includes('superintendent')) {
                this.projects = await API.getProjectsBySuperintendent()
                this.userType = 'superintendent'
            } else if (user.permissions.includes('payrollManager')) {
                this.projects = await API.getProjectsByPayrollManager()
                this.userType = 'payrollManager'
            } else {
                this.projects = await API.getProjectsByPM()
                this.userType = 'PM'
            }
            this.weekFilter = this.getCurrentWeek()
            const {
                data: { users },
            } = await API.getLiteUsers()
            this.users = users
            await this.loadData()
            await this.getUserList()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        getTimesheetUniqueKey(timesheet, projectId, externalUserId) {
            if (timesheet?.id) return timesheet.id
            const date = timesheet?.date || ''
            const clockIn =
                timesheet?.clockIn?._seconds ??
                timesheet?.clockIn?.seconds ??
                timesheet?.clockIn ??
                ''
            return `${projectId}-${externalUserId}-${date}-${clockIn}`
        },
        sortTimesheets(timesheets) {
            return [...(timesheets || [])].sort((a, b) => {
                const dateCompare = String(a.date || '').localeCompare(
                    String(b.date || '')
                )
                if (dateCompare !== 0) return dateCompare
                const aSec = a.clockIn?._seconds ?? a.clockIn?.seconds ?? 0
                const bSec = b.clockIn?._seconds ?? b.clockIn?.seconds ?? 0
                return aSec - bSec
            })
        },
        getPreviousReportName(year, week, month, monthStr) {
            if (this.filter === 'weekly') {
                let lastWeek = week - 1
                if (week === 1) {
                    lastWeek = 52
                }
                return `Week ${lastWeek}`
            }
            const months = this.availableMonths || moment.months()
            const idx = months.indexOf(monthStr)
            if (idx === -1) {
                return months[(month - 2 + 12) % 12]
            }
            return months[(idx - 1 + 12) % 12]
        },
        isProjectSuperApproved(user, reportName, projectId) {
            if (!user?.nomina || !projectId) return false
            const direct = user.nomina[reportName]
            if (
                direct?.superApproved &&
                (direct.projectsSuperApproved || []).includes(projectId)
            ) {
                return true
            }

            // Monthly view: accept week approvals that fall in this month
            if (this.filter === 'monthly') {
                const year = parseInt(this.yearFilter, 10)
                const month = new Date(`${reportName} 1, 2000`).getMonth() + 1
                for (const [key, entry] of Object.entries(user.nomina)) {
                    if (!entry?.superApproved) continue
                    if (
                        !(entry.projectsSuperApproved || []).includes(projectId)
                    ) {
                        continue
                    }
                    const weekMatch = String(key).match(/^Week\s+(\d+)$/i)
                    if (!weekMatch) continue
                    const weekNum = parseInt(weekMatch[1], 10)
                    const weekDates = this.getWeekDates(
                        this.getWeekStartDate(year, weekNum)
                    )
                    const overlapsMonth = weekDates.some(d => {
                        const parts = this.parseDateParts(d)
                        return (
                            parts &&
                            parts.month === month &&
                            parts.year === year
                        )
                    })
                    if (overlapsMonth) return true
                }
            }

            // Weekly view: also accept month approval covering this week
            if (this.filter === 'weekly') {
                const week = parseInt(this.weekFilter, 10)
                const year = parseInt(this.yearFilter, 10)
                const weekDates = this.getWeekDates(
                    this.getWeekStartDate(year, week)
                )
                for (const d of weekDates) {
                    const parts = this.parseDateParts(d)
                    if (!parts) continue
                    const monthName = moment()
                        .month(parts.month - 1)
                        .format('MMMM')
                    const monthEntry = user.nomina[monthName]
                    if (
                        monthEntry?.superApproved &&
                        (monthEntry.projectsSuperApproved || []).includes(
                            projectId
                        )
                    ) {
                        return true
                    }
                }
            }

            return false
        },
        getPmClosedReportNamesForPeriod(user, reportName, projectId) {
            const names = new Set()
            if (!user?.nomina || !projectId) return names

            const considerEntry = (key, entry) => {
                if (!entry?.closed) return
                if (!(entry.projectsPMApproved || []).includes(projectId)) {
                    return
                }
                names.add(key)
            }

            considerEntry(reportName, user.nomina[reportName])

            if (this.filter === 'monthly') {
                const year = parseInt(this.yearFilter, 10)
                const month = new Date(`${reportName} 1, 2000`).getMonth() + 1
                for (const [key, entry] of Object.entries(user.nomina)) {
                    const weekMatch = String(key).match(/^Week\s+(\d+)$/i)
                    if (!weekMatch) continue
                    const weekNum = parseInt(weekMatch[1], 10)
                    const weekDates = this.getWeekDates(
                        this.getWeekStartDate(year, weekNum)
                    )
                    const overlapsMonth = weekDates.some(d => {
                        const parts = this.parseDateParts(d)
                        return (
                            parts &&
                            parts.month === month &&
                            parts.year === year
                        )
                    })
                    if (overlapsMonth) considerEntry(key, entry)
                }
            }

            if (this.filter === 'weekly') {
                const week = parseInt(this.weekFilter, 10)
                const year = parseInt(this.yearFilter, 10)
                const weekDates = this.getWeekDates(
                    this.getWeekStartDate(year, week)
                )
                for (const d of weekDates) {
                    const parts = this.parseDateParts(d)
                    if (!parts) continue
                    const monthName = moment()
                        .month(parts.month - 1)
                        .format('MMMM')
                    considerEntry(monthName, user.nomina[monthName])
                }
            }

            return names
        },
        isProjectPMApproved(user, reportName, projectId) {
            return (
                this.getPmClosedReportNamesForPeriod(
                    user,
                    reportName,
                    projectId
                ).size > 0
            )
        },
        getTimesheetsFromPayrollSnapshot(payroll) {
            if (!payroll) return []
            if (
                Array.isArray(payroll.externalUsersData) &&
                payroll.externalUsersData.length
            ) {
                return this.sortTimesheets(payroll.externalUsersData)
            }
            const nested = (payroll.externalUsers || []).flatMap(user => {
                if (Array.isArray(user.timesheet)) {
                    return user.timesheet.map(ts => ({
                        name: user.name,
                        externalUserId: user.id,
                        role: user.role,
                        ...ts,
                    }))
                }
                if (user.timesheet && typeof user.timesheet === 'object') {
                    return Object.values(user.timesheet)
                        .flat()
                        .filter(Boolean)
                        .map(ts => ({
                            name: user.name,
                            externalUserId: user.id,
                            role: user.role,
                            ...ts,
                        }))
                }
                return []
            })
            return this.sortTimesheets(nested)
        },
        async loadData() {
            this.projects = this.projects
                .map(item => {
                    item.externalUsersData = []
                    item.externalUsers.forEach(user => {
                        const userTimesheets = []
                        const seenKeys = new Set()
                        Object.values(user.timesheet || {}).forEach(value => {
                            ;(value || []).forEach(timesheet => {
                                const tsProjectId =
                                    timesheet.projectId != null
                                        ? timesheet.projectId
                                        : item.id
                                if (tsProjectId !== item.id) return
                                const key = this.getTimesheetUniqueKey(
                                    timesheet,
                                    item.id,
                                    user.id
                                )
                                if (seenKeys.has(key)) return
                                seenKeys.add(key)
                                userTimesheets.push({
                                    name: user.name,
                                    externalUserId: user.id,
                                    role: user.role,
                                    ...timesheet,
                                    projectId: item.id,
                                })
                            })
                        })
                        item.externalUsersData.push(
                            this.sortTimesheets(userTimesheets)
                        )
                    })
                    return item
                })
                .filter(item =>
                    item.externalUsersData.some(arr => arr.length > 0)
                )
        },
        async getUserList() {
            const usersList = this.projects.flatMap(
                obj => obj.externalUsersData
            )
            const mapped = usersList
                .map(list => {
                    if (!list || list.length === 0) {
                        return null
                    }
                    const baseData = list[0]
                    const project = this.projects.find(
                        proj => proj.id === baseData.projectId
                    )
                    if (!project) {
                        return null
                    }

                    const user = project.externalUsers.find(
                        userdata => userdata.id === baseData.externalUserId
                    )

                    if (!user) {
                        return null
                    }
                    const payrollsData = this.getPayrollsForUser(
                        project,
                        user.id
                    )
                    return {
                        name: list[0].name,
                        ...user,
                        projectId: baseData.projectId,
                        projectName: project ? project.name : null,
                        externalUsersData: list,
                        rowKey: `${baseData.projectId}-${user.id}`,
                        payrolls: payrollsData,
                    }
                })
                .filter(Boolean)
            this.usersList = mapped.sort((a, b) =>
                (a.rowKey || '').localeCompare(b.rowKey || '')
            )
        },
        getPayrollsForUser(projectData, userId) {
            if (!projectData?.payrollReports?.length) return {}
            const userIdStr = userId != null ? String(userId) : ''
            const payrolls = projectData.payrollReports.filter(
                obj => String(obj.userId || '') === userIdStr
            )
            if (!payrolls.length) return {}
            const data = {}
            const sorted = [...payrolls].sort((a, b) =>
                String(a.period || '').localeCompare(String(b.period || ''))
            )
            for (const payroll of sorted) {
                const {
                    period,
                    userId: reportUserId,
                    finished: reportFinished,
                    ...reportData
                } = payroll
                const key = period != null ? String(period).trim() : ''
                if (key) {
                    const isFinished =
                        reportFinished === true ||
                        reportFinished === 'true' ||
                        reportFinished === 1
                    const existing = data[key]
                    // Prefer finished: true so we never overwrite Processed with Payroll (avoids duplicate payment)
                    if (!existing || (isFinished && !existing.finished)) {
                        data[key] = {
                            id: reportUserId,
                            ...reportData,
                            finished: isFinished,
                        }
                    }
                }
            }
            return data
        },
        getUserName(id) {
            if (this.users.length > 0) {
                return this.users.find(user => user.id == id)?.name
            } else {
                return ''
            }
        },
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD hh:mm A')
        },
        formatLocalDateYMD(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        parseDateParts(dateStr) {
            if (!dateStr || typeof dateStr !== 'string') return null
            const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/)
            if (!match) return null
            return {
                year: parseInt(match[1], 10),
                month: parseInt(match[2], 10),
                day: parseInt(match[3], 10),
            }
        },
        getCurrentWeek() {
            const now = new Date()
            const currentMonday = new Date(now)
            currentMonday.setDate(now.getDate() - ((now.getDay() + 6) % 7))
            const year = currentMonday.getFullYear()
            const firstDayOfYear = new Date(year, 0, 1).getDay()
            const firstMondayOffset =
                firstDayOfYear === 0 ? 1 : 1 - firstDayOfYear
            const firstMonday = new Date(year, 0, 1 + firstMondayOffset)
            return (
                1 + Math.floor((currentMonday - firstMonday) / (7 * 86400000))
            )
        },
        getWeekStartDate(year, week) {
            const firstDayOfYear = new Date(year, 0, 1).getDay()
            const firstMondayOffset =
                firstDayOfYear === 0 ? 1 : 1 - firstDayOfYear
            const firstMonday = new Date(year, 0, 1 + firstMondayOffset)
            const daysOffset = (week - 1) * 7
            const monday = new Date(firstMonday)
            monday.setDate(firstMonday.getDate() + daysOffset)
            return monday
        },
        getWeekDates(startDate) {
            return Array.from({ length: 7 }, (_, i) => {
                const date = new Date(startDate)
                date.setDate(startDate.getDate() + i)
                return this.formatLocalDateYMD(date)
            })
        },
        async openEditRecordDialog(item) {
            try {
                this.loading2 = true
                this.dialogEditRecord = true
                this.recordToEdit = item
                this.selectedNotes = item.notes || ''
                const project = this.projects.find(
                    obj => obj.id === item.projectId
                )
                this.scopeSelected = item.selectedCost?.cost.reference || null
                if (project != undefined) {
                    for (const quote of project.quotes) {
                        const response = await API.getCosts(quote.split('/')[0])
                        response.forEach(item => {
                            this.$set(this.itemsScopeSelected, item.reference, {
                                cost: {
                                    id: item.id,
                                    reference: item.reference,
                                    selected: true,
                                },
                                quote: {
                                    id: quote.split('/')[0],
                                    name: project.name,
                                },
                            })
                        })
                    }
                }
                if (item.selectedCost) {
                    this.$set(
                        this.itemsScopeSelected,
                        item.selectedCost.cost.reference,
                        item.selectedCost
                    )
                    this.scopeValue = this.itemsScopeSelected[
                        item.selectedCost.cost.reference
                    ]
                }
                if (item.otherCosts) {
                    this.otherCosts = item.otherCosts
                }
                if (item.clockIn) {
                    this.clockInSelected = this.convertTimestampToTime(
                        item.clockIn
                    )
                } else {
                    this.clockInSelected = { hh: '', mm: '', ss: '', a: '' }
                }
                if (item.clockOut) {
                    this.clockOutSelected = this.convertTimestampToTime(
                        item.clockOut
                    )
                } else {
                    this.clockOutSelected = { hh: '', mm: '', ss: '', a: '' }
                }
                if (
                    item.attachments &&
                    item.attachments.length > 0 &&
                    item.selectedCost
                ) {
                    let attachments = []
                    for (const doc of item.attachments) {
                        const storageRef = storage().ref(
                            `${this.companyId}/projects/${item.projectId}/filesExternalUsers/${item.selectedCost.quote.id}/${item.selectedCost.cost.id}`
                        )
                        if (doc.newFile || doc.url) {
                            attachments.push(doc)
                            continue
                        }
                        const documentRef = storageRef.child(doc)
                        await documentRef
                            .getDownloadURL()
                            .then(response => {
                                attachments.push({
                                    name: doc,
                                    url: response,
                                })
                            })
                            .catch(() => {
                                attachments.push({
                                    name: doc,
                                    url: '',
                                })
                            })
                    }
                    for (const file of attachments) {
                        if (file.name.includes('.pdf')) {
                            file.pdfPreview = await loadPDFPreview(file.url)
                        }
                    }
                    this.files = attachments
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.loading2 = false
            }
        },
        closeDialogEditRecord() {
            this.recordToEdit = {}
            this.clockInSelected = { hh: '', mm: '', ss: '', a: '' }
            this.clockOutSelected = { hh: '', mm: '', ss: '', a: '' }
            this.scopeSelected = null
            this.itemsScopeSelected = {}
            this.scopeValue = null
            this.selectedNotes = ''
            this.notesSelected = ''
            this.dialogEditRecord = false
            this.files = []
            this.temporalAttachments = []
            this.deleteAttachments = []
            this.otherCosts = 0
        },
        async openReportDialog(item) {
            try {
                this.loading2 = true
                this.reportUser = _.cloneDeep(item)
                let reportName = this.monthFilter
                if (this.filter == 'weekly') {
                    reportName = `Week ${this.weekFilter}`
                }
                // Only reuse a payroll saved for THIS period (Week N / July).
                // Never open a weekly payroll when viewing monthly — consolidate instead.
                const payrollForPeriod = this.getPayrollEntryForReport(
                    item.payrolls,
                    reportName
                )
                if (payrollForPeriod && payrollForPeriod.created) {
                    this.reportData = _.cloneDeep(payrollForPeriod)
                    if (
                        !this.reportData.externalUsersData ||
                        !this.reportData.externalUsersData.length
                    ) {
                        const snapshot = this.getTimesheetsFromPayrollSnapshot(
                            this.reportData
                        )
                        if (snapshot.length) {
                            this.reportData.externalUsersData = snapshot
                        }
                    } else {
                        this.reportData.externalUsersData = this.sortTimesheets(
                            this.reportData.externalUsersData
                        )
                    }
                    this.originalReport = _.cloneDeep(this.reportData)
                } else {
                    this.originalReport = {}
                    this.reportData = _.cloneDeep({
                        ...this.reportData,
                        ...(payrollForPeriod || {}),
                    })
                    this.originalReport = _.cloneDeep(payrollForPeriod || {})
                    this.reportData.userName = item.name
                    this.reportData.role = item.role
                    this.reportData.email = item.email
                    this.reportData.phone = item.phone
                    this.reportData.hourlyPrice = parseFloat(item.hourlyPrice)
                    // Consolidate all PM-closed weeks (or weeks in month) into one report
                    this.reportData.externalUsersData = await this.getTimeSheetsInDate()
                    if (!this.reportData.externalUsersData.length) {
                        this.closeDialogReport()
                        return
                    }
                    this.reportData.date = this.getDateRange(
                        this.reportData.externalUsersData
                    )
                    this.reportData.totalHours = this.getTotalHours(
                        this.reportData
                    )
                    this.reportData.overtimeHours = parseFloat(
                        this.getOvertimeHours(this.reportData)
                    )
                    this.reportData.otherCosts = parseFloat(
                        this.setOtherCosts(this.reportData)
                    )
                    this.reportData.created = true
                }
                this.reportData.createdBy = await this.getUserName(this.userId)
                if (
                    this.reportData.attachments &&
                    this.reportData.attachments.length > 0
                ) {
                    let attachments = []
                    for (const doc of this.reportData.attachments) {
                        const storageRef = storage().ref(
                            `${this.companyId}/projects/${this.reportUser.projectId}/payrolls`
                        )
                        if (doc.newFile || doc.url) {
                            attachments.push(doc)
                            continue
                        }
                        const documentRef = storageRef.child(doc)
                        await documentRef
                            .getDownloadURL()
                            .then(response => {
                                attachments.push({
                                    name: doc,
                                    url: response,
                                })
                            })
                            .catch(() => {
                                attachments.push({
                                    name: doc,
                                    url: '',
                                })
                            })
                    }
                    for (const file of attachments) {
                        if (file.name.includes('.pdf')) {
                            file.pdfPreview = await loadPDFPreview(file.url)
                        }
                    }
                    this.$set(this.reportData, 'attachments', attachments)
                }
                this.dialogReport = true
            } catch (error) {
                console.error(error)
            } finally {
                this.loading2 = false
            }
        },
        async saveReport(finished = false) {
            try {
                this.loading2 = true
                const userIndex = this.usersList.findIndex(
                    user => user.rowKey === this.reportUser.rowKey
                )
                let reportName = ''
                let user = {}
                if (!this.reportData.attachments) {
                    this.reportData.attachments = []
                }
                if (userIndex != -1) {
                    user = this.usersList[userIndex]
                    if (!user.payrolls) {
                        this.$set(user, 'payrolls', {})
                    }
                    if (this.filter == 'weekly') {
                        reportName = `Week ${this.weekFilter}`
                    } else {
                        reportName = this.monthFilter
                    }
                    this.$set(user.payrolls, reportName, this.reportData)
                    if (finished) {
                        this.$set(user.payrolls[reportName], 'finished', true)
                    }
                }
                for (const file of this.localAttachments) {
                    await saveFile(
                        file,
                        `${this.companyId}/projects/${this.reportUser.projectId}/payrolls`
                    )
                }
                if (this.deleteFiles.length > 0) {
                    for (const file of this.deleteFiles) {
                        if (file.exist) {
                            await deleteFile(
                                file.name,
                                `${this.companyId}/projects/${this.reportUser.projectId}/payrolls`
                            )
                        }
                    }
                    await API.deleteAttachmentPayroll({
                        projectId: this.reportUser.projectId,
                        externalUserId: this.reportUser.id,
                        reportId: this.reportData.reportId,
                        deleteFiles: this.deleteFiles.map(file => file.name),
                    })
                }
                this.reportData.totalOvertime = parseFloat(
                    this.getTotalOvertime
                )
                const diff = objDiff(this.originalReport, this.reportData)
                if (diff.attachments) {
                    delete diff.attachments
                    diff.attachments = this.localAttachments.map(
                        item => item.name
                    )
                }
                await API.reportPayroll({
                    projectId: this.reportUser.projectId,
                    externalUserId: this.reportUser.id,
                    reportId: this.reportData.reportId,
                    ...diff,
                    ...(finished ? { finished: true } : {}),
                })
                const fullAttachments = [
                    ...this.reportData.attachments.map(item => item.name),
                ]
                this.$set(
                    user.payrolls[reportName],
                    'attachments',
                    fullAttachments
                )
                if (finished) {
                    const path = `${this.companyId}/projects/${this.reportUser.projectId}/payrolls`
                    let storageRef = storage().ref(path)
                    let attachmentsToReport = []
                    if (fullAttachments.length > 0) {
                        for (const file of fullAttachments) {
                            const attachmentRef = storageRef.child(file)
                            await attachmentRef
                                .getDownloadURL()
                                .then(URL => {
                                    attachmentsToReport.push({
                                        name: file,
                                        url: URL,
                                    })
                                })
                                .catch(error => {
                                    error & true
                                })
                        }
                    }
                    for (const attachment of attachmentsToReport) {
                        const isPDF = attachment.name.includes('.pdf')
                        if (isPDF) {
                            const dataURL = await loadPDFPreview(attachment.url)
                            const file = dataURLtoFile(dataURL, attachment.name)
                            const imageFile = new File(
                                [file],
                                `firstPage ${file.name.replace(
                                    /\.pdf$/,
                                    '.png'
                                )}`,
                                {
                                    type: file.type,
                                    lastModified: file.lastModified,
                                }
                            )
                            const imagePath = `${this.companyId}/projects/${
                                this.reportUser.projectId
                            }/payrolls/firstPage ${file.name.replace(
                                /\.pdf$/,
                                ''
                            )}`
                            const storageRef = storage().ref(imagePath)
                            await storageRef.put(imageFile)
                            attachment.firstPageURL = URL.createObjectURL(file)
                            attachment.isPDF = isPDF
                        }
                    }
                    this.reportData.attachments = attachmentsToReport
                    const htmlContent = await generateHTMLReport(
                        this.reportData,
                        false
                    )
                    const path2 = `${this.companyId}/projects/${this.reportUser.projectId}/payrolls/Payroll_${this.reportData.userName}_${this.reportData.date}`
                    storageRef = storage().ref(path2)
                    await storageRef.put(htmlContent)
                    this.reportData.attachments = fullAttachments
                    const reportEmail =
                        this.reportData.email &&
                        String(this.reportData.email).trim()
                    if (reportEmail) {
                        await API.sendPayrollEmail({
                            subject: `Payroll ${this.reportData.userName} ${this.reportData.date}`,
                            to: [this.reportData.email],
                            cc: [],
                            projectId: this.reportUser.projectId,
                            report: this.reportData,
                            reportPath: `Payroll_${this.reportData.userName}_${this.reportData.date}`,
                        })
                    }
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.loading2 = false
                this.closeDialogReport()
            }
        },
        async getTimeSheetsInDate() {
            const reportName =
                this.filter == 'weekly'
                    ? `Week ${this.weekFilter}`
                    : this.monthFilter
            const fullUser =
                this.usersList.find(
                    user => user.rowKey === this.reportUser.rowKey
                ) || this.reportUser
            const allowedNames = new Set([reportName])
            this.getPmClosedReportNamesForPeriod(
                fullUser,
                reportName,
                fullUser.projectId
            ).forEach(name => allowedNames.add(name))
            let temporalTimesheets = [...(fullUser.externalUsersData || [])]
            temporalTimesheets = temporalTimesheets.filter(ts =>
                allowedNames.has(ts.nomina)
            )
            return this.sortTimesheets(temporalTimesheets)
        },
        getDateRange(dataList) {
            if (!dataList.length) return ''
            const dates = dataList.map(item => item.date).sort()

            const oldestDate = new Date(dates[0])
            const newestDate = new Date(dates[dates.length - 1])

            const options = { year: 'numeric', month: 'long', day: 'numeric' }
            const formattedOldest = oldestDate.toLocaleDateString(
                'en-US',
                options
            )
            const formattedNewest = newestDate.toLocaleDateString(
                'en-US',
                options
            )
            return `From ${formattedOldest} to ${formattedNewest}`
        },
        closeDialogReport() {
            this.dialogReport = false
            this.reportUser = {}
            this.deleteFiles = []
            this.localAttachments = []
            this.reportData = {
                totalHours: 0.0,
                overtimeHours: 0.0,
                reportNotes: '',
                otherCosts: 0.0,
                hourlyPrice: 0.0,
                userName: null,
                role: null,
                email: null,
                phone: null,
                name: null,
                externalUsersData: [],
                date: '',
                attachments: [],
                created: false,
            }
            this.originalReport = {}
        },
        convertTimestampToTime(timeObj) {
            const seconds =
                timeObj?._seconds ??
                timeObj?.seconds ??
                (typeof timeObj === 'number' ? timeObj : null)
            if (typeof seconds !== 'number') {
                return { hh: '', mm: '', ss: '', a: '' }
            }

            const date = new Date(seconds * 1000)
            let hh = date.getHours()
            const mm = String(date.getMinutes()).padStart(2, '0')
            const ss = String(date.getSeconds()).padStart(2, '0')
            const a = hh >= 12 ? 'pm' : 'am'

            hh = hh % 12 || 12

            return {
                hh: String(hh).padStart(2, '0'),
                mm,
                ss,
                a,
            }
        },
        openDeleteRecordDialog(item) {
            this.recordToDelete = item
            this.dialogDeleteRecord = true
        },
        closeDialogDeleteRecord() {
            this.dialogDeleteRecord = false
            this.recordToDelete = {}
        },
        async deleteRecord() {
            try {
                this.loading2 = true
                const userRecord = this.usersList.findIndex(
                    user =>
                        user.projectId === this.recordToDelete.projectId &&
                        user.id === this.recordToDelete.externalUserId
                )
                if (userRecord != -1) {
                    const recordIndex = this.usersList[
                        userRecord
                    ].externalUsersData.findIndex(
                        record => record.id === this.recordToDelete.id
                    )
                    if (recordIndex != -1) {
                        this.usersList[userRecord].externalUsersData.splice(
                            recordIndex,
                            1
                        )
                    }
                }
                await API.deleteTimeSheet({
                    externalUserId: this.recordToDelete.externalUserId,
                    id: this.recordToDelete.id,
                })
            } catch (error) {
                console.error(error)
            } finally {
                this.loading2 = false
                this.closeDialogDeleteRecord()
            }
        },
        async editRecord() {
            try {
                this.loading2 = true
                const defaultTime = { hh: '', mm: '', ss: '', a: '' }
                const userRecordIndex = this.usersList.findIndex(
                    user =>
                        user.projectId === this.recordToEdit.projectId &&
                        user.id === this.recordToEdit.externalUserId
                )
                if (userRecordIndex === -1) {
                    throw new Error('User record not found for this project')
                }
                const userRecord = this.usersList[userRecordIndex]
                const recordIndex = userRecord.externalUsersData.findIndex(
                    record => record.id === this.recordToEdit.id
                )

                if (recordIndex === -1) {
                    throw new Error('Timesheet record not found')
                }

                const record = userRecord.externalUsersData[recordIndex]
                const scopeId = this.scopeValue?.cost?.id
                const selectedId = this.recordToEdit?.selectedCost?.cost?.id
                const attachments = this.recordToEdit?.attachments

                if (
                    scopeId &&
                    selectedId &&
                    attachments &&
                    scopeId !== selectedId
                ) {
                    for (const file of this.files) {
                        if (!file.newFile) {
                            const response = await fetch(file.url)
                            if (!response.ok) {
                                throw new Error('download file error')
                            }
                            const blob = await response.blob()
                            const newFile = new File([blob], file.name, {
                                type: blob.type,
                            })
                            if (
                                this.scopeValue?.quote?.id &&
                                this.scopeValue?.cost?.id
                            ) {
                                await saveFile(
                                    newFile,
                                    `${this.companyId}/projects/${this.recordToEdit.projectId}/filesExternalUsers/${this.scopeValue.quote.id}/${this.scopeValue.cost.id}`
                                )
                            }
                            if (
                                this.recordToEdit?.selectedCost?.quote?.id &&
                                this.recordToEdit?.selectedCost?.cost?.id
                            ) {
                                await deleteFile(
                                    file.name,
                                    `${this.companyId}/projects/${this.recordToEdit.projectId}/filesExternalUsers/${this.recordToEdit.selectedCost.quote.id}/${this.recordToEdit.selectedCost.cost.id}`
                                )
                            }
                            if (this.files.length) {
                                const attachmentsFiles = this.files.map(
                                    file => file.name
                                )
                                record.attachments = attachmentsFiles
                            }
                        }
                    }
                }
                if (this.deleteAttachments.length) {
                    for (const file of this.deleteAttachments) {
                        if (
                            file.exist &&
                            this.recordToEdit?.selectedCost?.quote?.id &&
                            this.recordToEdit?.selectedCost?.cost?.id
                        ) {
                            await deleteFile(
                                file.name,
                                `${this.companyId}/projects/${this.recordToEdit.projectId}/filesExternalUsers/${this.recordToEdit.selectedCost.quote.id}/${this.recordToEdit.selectedCost.cost.id}`
                            )
                            if (this.files.length) {
                                const attachmentsFiles = this.files.map(
                                    file => file.name
                                )
                                record.attachments = attachmentsFiles
                            }
                        }
                    }
                }
                if (this.temporalAttachments.length) {
                    for (const file of this.temporalAttachments) {
                        if (
                            this.scopeValue?.quote?.id &&
                            this.scopeValue?.cost?.id
                        ) {
                            await saveFile(
                                file,
                                `${this.companyId}/projects/${this.recordToEdit.projectId}/filesExternalUsers/${this.scopeValue.quote.id}/${this.scopeValue.cost.id}`
                            )
                            if (this.files.length) {
                                const attachmentsFiles = this.files.map(
                                    file => file.name
                                )
                                record.attachments = attachmentsFiles
                            }
                        }
                    }
                }

                if (
                    this.clockInSelected &&
                    JSON.stringify(this.clockInSelected) !==
                        JSON.stringify(defaultTime)
                ) {
                    record.clockIn = this.convertToTimestamp(
                        record.date,
                        this.clockInSelected
                    )
                }
                if (
                    this.clockOutSelected &&
                    JSON.stringify(this.clockOutSelected) !==
                        JSON.stringify(defaultTime)
                ) {
                    record.clockOut = this.convertToTimestamp(
                        record.date,
                        this.clockOutSelected
                    )
                    if (!record.clockOutLocation && record.clockInLocation) {
                        record.clockOutLocation = record.clockInLocation
                    }
                }
                record.notes = this.selectedNotes
                record.selectedCost = this.scopeValue
                record.otherCosts = parseFloat(this.otherCosts) || 0
                this.$set(userRecord.externalUsersData, recordIndex, {
                    ...record,
                })
                this.usersList = [...this.usersList]
                await API.updateTimeSheet({
                    id: record.id,
                    externalUserId: record.externalUserId,
                    ...(record.clockIn && { clockIn: record.clockIn }),
                    ...(record.clockOut && {
                        clockOut: record.clockOut,
                    }),
                    ...(record.clockInLocation && {
                        clockInLocation: record.clockInLocation,
                    }),
                    ...(record.clockOutLocation && {
                        clockOutLocation: record.clockOutLocation,
                    }),
                    ...(record.selectedCost && {
                        selectedCost: record.selectedCost,
                    }),
                    notes: record.notes ?? '',
                    ...(record.attachments && {
                        attachments: record.attachments,
                    }),
                    otherCosts: record.otherCosts,
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message || 'Failed to update timesheet',
                })
            } finally {
                this.loading2 = false
                this.closeDialogEditRecord()
            }
        },
        async saveReportXLSX() {
            let report = []
            this.projects.forEach(project => {
                ;(project.payrollReports || []).forEach(payroll => {
                    ;(payroll.externalUsersData || []).forEach(user => {
                        const cost = user.selectedCost?.cost
                        const quote = user.selectedCost?.quote
                        const clockIn = user.clockIn
                        const clockOut = user.clockOut

                        if (cost && quote && clockIn && clockOut) {
                            const clockInSec =
                                clockIn._seconds + clockIn._nanoseconds / 1e9
                            const clockOutSec =
                                clockOut._seconds + clockOut._nanoseconds / 1e9
                            let rawHours = (clockOutSec - clockInSec) / 3600
                            if (rawHours > 8) {
                                rawHours = 8.0
                            }
                            const hours = parseFloat(rawHours.toFixed(2))
                            const existing = report.find(r => r.id === cost.id)

                            if (existing) {
                                existing.hours += hours
                            } else {
                                report.push({
                                    quoteId: quote.id,
                                    scopeName: cost.reference,
                                    projectName: payroll.name,
                                    projectId: project.id,
                                    projectQuotes: project.quotes.map(quote => {
                                        return quote.split('/')[0]
                                    }),
                                    name: `${payroll.name} - ${cost.reference}`,
                                    id: cost.id,
                                    overtimeHours: parseFloat(
                                        (payroll.overtimeHours || 0).toFixed(2)
                                    ),
                                    hours,
                                    space: '',
                                    hourlyPrice: parseFloat(
                                        (payroll.hourlyPrice || 0).toFixed(2)
                                    ),
                                })
                            }
                        }
                    })
                })
            })

            const reportData = await this.enrichDataWithHourlyAndSQFT(report)
            const headers = [
                { header: 'PROJECT IN PROCESS', key: 'name' },
                { header: 'SQFT', key: 'SQFT' },
                { header: 'Hours.', key: 'hours' },
                { header: 'Overtime.', key: 'overtimeHours' },
                { header: 'TOTAL HOURS', key: 'totalHours' },
                { header: 'Hour Value', key: 'hourlyPrice' },
                { header: 'Overtime Value', key: 'hourlyOvertime' },
                { header: 'Contractor Value', key: 'space' },
                { header: 'TOTAL HOURS VALUE', key: 'totalCost' },
                { header: '$/SQFT', key: 'real' },
                { header: 'BUDGET $/SQFT', key: 'expected' },
            ]
            const headerRow = headers.map(h => h.header)
            const dataRows = reportData.map(item =>
                headers.map(h => item[h.key])
            )
            const worksheetData = [headerRow, ...dataRows]
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, worksheet, 'report')
            XLSX.writeFile(workbook, 'PayrollReport.xlsx')
        },
        async enrichDataWithHourlyAndSQFT(dataList) {
            for (const item of dataList) {
                const hours = parseFloat(item.hours) || 0
                item.hourlyOvertime = parseFloat(
                    (item.hourlyPrice * 1.015).toFixed(2)
                )
                item.totalHours = parseFloat(
                    (hours + parseFloat(item.overtimeHours || 0)).toFixed(2)
                )
                const totalCost = parseFloat(
                    (
                        hours * item.hourlyPrice +
                        item.overtimeHours * item.hourlyOvertime
                    ).toFixed(2)
                )
                item.totalCost = totalCost
                let sqft = 0
                let costs = {}
                if (item.projectQuotes && item.projectQuotes.length > 0) {
                    for (const quoteId of item.projectQuotes) {
                        const scopes = await API.getCosts(quoteId)
                        costs[quoteId] = scopes
                    }
                }
                try {
                    const response = costs[item.quoteId]
                    if (Array.isArray(response)) {
                        const matched = response.find(
                            cost => cost.id === item.id
                        )
                        if (matched && matched.quantity != null) {
                            let installationValue = 0
                            if (Array.isArray(matched.sections)) {
                                matched.sections.forEach(obj => {
                                    if (Array.isArray(obj.items)) {
                                        obj.items.forEach(item => {
                                            if (item.installation) {
                                                installationValue +=
                                                    parseFloat(item.parcial) ||
                                                    0
                                            }
                                        })
                                    }
                                })
                            }
                            if (
                                Array.isArray(matched?.associateScopes) &&
                                matched.associateScopes.length > 0
                            ) {
                                matched.associateScopes.forEach(
                                    costAssociated => {
                                        const scopes =
                                            costs[costAssociated.quoteId]
                                        let scope = null
                                        if (scopes && scopes.length > 0) {
                                            scope = scopes.find(
                                                cost =>
                                                    cost.id ===
                                                    costAssociated.scopeId
                                            )
                                        }
                                        if (scope) {
                                            sqft +=
                                                parseFloat(
                                                    scope.quantity.toFixed(2)
                                                ) || 0
                                            if (Array.isArray(scope.sections)) {
                                                scope.sections.forEach(obj => {
                                                    if (
                                                        Array.isArray(obj.items)
                                                    ) {
                                                        obj.items.forEach(
                                                            item => {
                                                                if (
                                                                    item.installation
                                                                ) {
                                                                    installationValue +=
                                                                        parseFloat(
                                                                            item.parcial
                                                                        ) || 0
                                                                }
                                                            }
                                                        )
                                                    }
                                                })
                                            }
                                        }
                                    }
                                )
                            }
                            item.installationValue = installationValue
                            sqft += matched.quantity
                                ? parseFloat(matched.quantity.toFixed(2))
                                : 0
                        }
                    }
                } catch (error) {
                    console.error(
                        `Error fetching cost data for quoteId ${item.quoteId}:`,
                        error
                    )
                }
                item.SQFT = sqft
                item.expected = sqft
                    ? parseFloat((item.installationValue / sqft).toFixed(2))
                    : 0

                item.real = sqft ? parseFloat((totalCost / sqft).toFixed(2)) : 0
            }

            return dataList
        },
        convertToTimestamp(dateString, time) {
            let hours = parseInt(time.hh)
            if (time.a === 'pm' && hours !== 12) {
                hours += 12
            } else if (time.a === 'am' && hours === 12) {
                hours = 0
            }
            const minutes = parseInt(time.mm)
            const seconds = parseInt(time.ss)
            const dateTime = moment(
                `${dateString} ${hours}:${minutes}:${seconds}`,
                'YYYY-MM-DD HH:mm:ss'
            )
            return {
                _seconds: dateTime.unix(),
                _nanoseconds: 0,
            }
        },
        getDayOfWeek(dateString) {
            return moment(dateString, 'YYYY-MM-DD').format('dddd')
        },
        updateValue() {
            this.scopeValue = this.itemsScopeSelected[this.scopeSelected]
        },
        getReportName() {
            return this.filter === 'weekly'
                ? `Week ${this.weekFilter}`
                : this.monthFilter
        },
        getWorkflowStatus(item) {
            const baseStatus = this.getStatus(item)
            if (baseStatus === 'Processed') return 'processed'
            if (baseStatus === 'Payroll') return 'payroll'
            const reportName = this.getReportName()
            if (
                this.isProjectSuperApproved(
                    item,
                    reportName,
                    item.projectId
                )
            ) {
                return 'pmReview'
            }
            return 'superintendentReview'
        },
        getWorkflowStatusLabel(workflowStatus) {
            const labels = {
                superintendentReview: 'Superintendent Review',
                pmReview: 'PM Review',
                payroll: 'Ready for Payroll',
                processed: 'Processed',
            }
            return labels[workflowStatus] || workflowStatus
        },
        getWorkflowStatusColor(workflowStatus) {
            const colors = {
                superintendentReview: 'orange darken-1',
                pmReview: 'blue darken-1',
                payroll: 'primary',
                processed: 'success',
            }
            return colors[workflowStatus] || 'grey'
        },
        getStatus(item) {
            const reportName = this.getReportName()

            const payrollEntry = this.getPayrollEntryForReport(
                item.payrolls,
                reportName
            )

            if (payrollEntry != null) {
                const isFinished =
                    payrollEntry.finished === true ||
                    payrollEntry.finished === 'true' ||
                    payrollEntry.finished === 1
                return isFinished ? 'Processed' : 'Payroll'
            }

            const closedReportNames = this.getPmClosedReportNamesForPeriod(
                item,
                reportName,
                item.projectId
            )
            // Cross-period PM closures (e.g. Week 29 inside July) mean the
            // period is ready for payroll manager — do not inherit Processed
            // from a weekly payroll doc when viewing the month.
            if (closedReportNames.size > 0) {
                return 'Payroll'
            }

            if (!item.nomina) return 'Pending'

            const nominaEntry = item.nomina?.[reportName]
            const projectsPMApproved = nominaEntry?.projectsPMApproved || []

            if (
                nominaEntry?.closed &&
                item.projectId &&
                projectsPMApproved.includes(item.projectId)
            ) {
                return 'Payroll'
            }

            return 'Pending'
        },
        getPayrollEntryForReport(payrolls, reportName) {
            if (!payrolls || typeof payrolls !== 'object') return undefined
            const exact = payrolls[reportName]
            if (exact !== undefined && exact !== null) return exact
            const reportNameNorm = String(reportName)
                .trim()
                .toLowerCase()
            for (const key of Object.keys(payrolls)) {
                if (
                    String(key)
                        .trim()
                        .toLowerCase() === reportNameNorm
                ) {
                    return payrolls[key]
                }
            }
            return undefined
        },
        getStatusTimeSheets(item) {
            if (item.nomina) {
                return 'Closed'
            } else {
                return 'Open'
            }
        },
        getTotalHours(item) {
            let totalHours = 0
            item.externalUsersData.forEach(timesheet => {
                if (timesheet.clockIn && timesheet.clockOut) {
                    totalHours +=
                        (timesheet.clockOut._seconds -
                            timesheet.clockIn._seconds) /
                        3600
                }
            })
            if (item.lastExternalUsersData) {
                item.lastExternalUsersData.forEach(timesheet => {
                    if (timesheet.clockIn && timesheet.clockOut) {
                        totalHours +=
                            (timesheet.clockOut._seconds -
                                timesheet.clockIn._seconds) /
                            3600
                    }
                })
            }

            return this.roundToNextHalfOrWhole(totalHours)
        },
        getOvertimeHours(item) {
            let totalHours = 0
            if (item.subcontracted) {
                return totalHours.toFixed(2)
            }

            item.externalUsersData.forEach(timesheet => {
                if (timesheet.clockIn && timesheet.clockOut) {
                    const hours =
                        (timesheet.clockOut._seconds -
                            timesheet.clockIn._seconds) /
                        3600
                    if (hours > 8) {
                        totalHours += hours - 8
                    }
                }
            })
            if (item.lastExternalUsersData) {
                item.lastExternalUsersData.forEach(timesheet => {
                    if (timesheet.clockIn && timesheet.clockOut) {
                        const hours =
                            (timesheet.clockOut._seconds -
                                timesheet.clockIn._seconds) /
                            3600
                        if (hours > 8) {
                            totalHours += hours - 8
                        }
                    }
                })
            }

            return this.roundToNextHalfOrWhole(totalHours)
        },
        roundToNextHalfOrWhole(num) {
            return Math.ceil(num * 2) / 2
        },
        async openFileAttached(file) {
            try {
                this.loading2 = true
                const localFile = this.localAttachments.find(
                    f => f.name == file
                )
                const savedFile = this.reportData.attachments.find(
                    f => f.name == file
                )
                if (localFile) {
                    const url = URL.createObjectURL(localFile)
                    window.open(url, '_blank')
                } else if (savedFile) {
                    window.open(savedFile.url, '_blank')
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async deleteFile(file) {
            try {
                this.loading2 = true
                const checkFile = this.reportData.attachments.find(
                    f => f.name == file
                )
                if (checkFile.newFile) {
                    this.localAttachments = this.localAttachments.filter(
                        f => f.name != file
                    )
                    this.reportData.attachments = this.reportData.attachments.filter(
                        f => f.name != file
                    )
                } else {
                    if (checkFile.url) {
                        this.deleteFiles.push({ name: file, exist: true })
                    } else {
                        this.deleteFiles.push({ name: file, exist: false })
                    }
                    this.reportData.attachments = this.reportData.attachments.filter(
                        f => f.name != file
                    )
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        onButtonClick() {
            this.$refs.uploader2.click()
        },
        onButtonClick2() {
            this.$refs.uploader1.click()
        },
        async onFileChanged(e) {
            await this.saveFile(e.target.files[0])
        },
        async onFileChanged2(e) {
            await this.saveFile2(e.target.files[0])
        },
        async saveFile(file) {
            try {
                this.loading2 = true
                const lastDotIndex = file.name.lastIndexOf('.')
                const baseName =
                    lastDotIndex !== -1
                        ? file.name.slice(0, lastDotIndex)
                        : file.name
                const ext =
                    lastDotIndex !== -1 ? file.name.slice(lastDotIndex + 1) : ''
                let newName = file.name
                let counter = 1
                const existingNames = this.reportData.attachments
                    ? this.reportData.attachments.map(att => att.name)
                    : []

                while (existingNames.includes(newName)) {
                    newName = ext
                        ? `${baseName}(${counter}).${ext}`
                        : `${baseName}(${counter})`
                    counter++
                }
                const newFile = new File([file], newName, { type: file.type })
                this.localAttachments.push(newFile)
                if (newFile.name.includes('.pdf')) {
                    newFile.pdfPreview = await loadPDFPreview(
                        URL.createObjectURL(newFile)
                    )
                }
                if (!this.reportData.attachments) {
                    this.reportData.attachments = [
                        {
                            name: newFile.name,
                            url: URL.createObjectURL(newFile),
                            ...(newFile.pdfPreview
                                ? { pdfPreview: newFile.pdfPreview }
                                : {}),
                            newFile: true,
                        },
                    ]
                } else {
                    this.reportData.attachments.push({
                        name: newFile.name,
                        url: URL.createObjectURL(newFile),
                        ...(newFile.pdfPreview
                            ? { pdfPreview: newFile.pdfPreview }
                            : {}),
                        newFile: true,
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async saveFile2(file) {
            try {
                this.loading2 = true
                const lastDotIndex = file.name.lastIndexOf('.')
                const baseName =
                    lastDotIndex !== -1
                        ? file.name.slice(0, lastDotIndex)
                        : file.name
                const ext =
                    lastDotIndex !== -1 ? file.name.slice(lastDotIndex + 1) : ''
                let newName = file.name
                let counter = 1
                const existingNames = this.files
                    ? this.files.map(att => att.name)
                    : []

                while (existingNames.includes(newName)) {
                    newName = ext
                        ? `${baseName}(${counter}).${ext}`
                        : `${baseName}(${counter})`
                    counter++
                }
                const newFile = new File([file], newName, { type: file.type })
                this.temporalAttachments.push(newFile)
                if (newFile.name.includes('.pdf')) {
                    newFile.pdfPreview = await loadPDFPreview(
                        URL.createObjectURL(newFile)
                    )
                }
                if (!this.files) {
                    this.files = [
                        {
                            name: newFile.name,
                            url: URL.createObjectURL(newFile),
                            ...(newFile.pdfPreview
                                ? { pdfPreview: newFile.pdfPreview }
                                : {}),
                            newFile: true,
                        },
                    ]
                } else {
                    this.files.push({
                        name: newFile.name,
                        url: URL.createObjectURL(newFile),
                        ...(newFile.pdfPreview
                            ? { pdfPreview: newFile.pdfPreview }
                            : {}),
                        newFile: true,
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        formatTime(time) {
            const seconds = time?._seconds ?? time?.seconds
            if (typeof seconds !== 'number') return ''
            return moment.unix(seconds).format('hh:mm A')
        },
        getUsersWithoutNomina(data) {
            if (
                !data ||
                !data.lastExternalUsersData ||
                !data.externalUsersData
            ) {
                throw new Error(
                    'The input object does not have the expected format.'
                )
            }
            const allUsers = [
                ...data.lastExternalUsersData,
                ...data.externalUsersData,
            ]
            const usersWithoutNomina = allUsers.filter(
                user => !Object.prototype.hasOwnProperty.call(user, 'nomina')
            )
            const uniqueIds = [
                ...new Set(usersWithoutNomina.map(user => user.id)),
            ]
            return uniqueIds
        },
        getTimesheetsForRow(row, listKey) {
            const list = row[listKey] || []
            const projectId = row.projectId
            if (!projectId) return this.sortTimesheets(list)
            const filtered = list.filter(ts => ts.projectId === projectId)
            const seenKeys = new Set()
            const deduped = filtered.filter(ts => {
                const key = this.getTimesheetUniqueKey(
                    ts,
                    projectId,
                    ts.externalUserId || row.id
                )
                if (seenKeys.has(key)) return false
                seenKeys.add(key)
                return true
            })
            return this.sortTimesheets(deduped)
        },
        filterTimesheetsByDates(
            timesheets,
            dates,
            user,
            reportType,
            reportName
        ) {
            const list = timesheets || []
            const dateSet = new Set(dates || [])
            return this.sortTimesheets(
                list.filter(ts => {
                    const inPeriod =
                        dateSet.has(ts.date) ||
                        (reportType === 'current' &&
                            this.filter === 'weekly' &&
                            ts.date &&
                            this.isDateInWeek(ts.date)) ||
                        (reportType === 'current' &&
                            this.filter === 'monthly' &&
                            ts.date &&
                            this.isDateInMonth(ts.date))
                    return (
                        inPeriod &&
                        this.shouldIncludeTimesheet(
                            ts,
                            user,
                            reportType,
                            reportName
                        )
                    )
                })
            )
        },
        shouldIncludeTimesheet(timesheet, user, reportType, reportName) {
            const status = this.getStatus(user)
            const timesheetStatus = this.getStatusTimeSheets(timesheet)
            if (status === 'Pending') {
                return timesheetStatus === 'Open'
            }
            if (status !== 'Pending') {
                if (timesheetStatus !== 'Closed') return false
                if (timesheet.nomina === reportName) return true
                const closedNames = this.getPmClosedReportNamesForPeriod(
                    user,
                    reportName,
                    user.projectId
                )
                return closedNames.has(timesheet.nomina)
            }
            return false
        },
        async closePayroll() {
            try {
                this.loading2 = true
                const uniqueIds = this.getUsersWithoutNomina(this.itemToClose)
                const userIndex = this.usersList.findIndex(
                    user => user.rowKey === this.itemToClose.rowKey
                )
                let reportName = this.monthFilter
                if (this.filter == 'weekly') {
                    reportName = `Week ${this.weekFilter}`
                }
                if (this.userType == 'superintendent') {
                    if (userIndex != -1) {
                        const user = this.usersList[userIndex]
                        if (!user.nomina) {
                            this.$set(user, 'nomina', {})
                        }
                        const existingNomina = user.nomina[reportName] || {}
                        const existingProjectsSuperApproved =
                            existingNomina.projectsSuperApproved || []
                        const projectsSuperApproved = existingProjectsSuperApproved.includes(
                            this.itemToClose.projectId
                        )
                            ? existingProjectsSuperApproved
                            : [
                                  ...existingProjectsSuperApproved,
                                  this.itemToClose.projectId,
                              ]
                        this.$set(user.nomina, reportName, {
                            ...existingNomina,
                            superApproved: true,
                            projectsSuperApproved,
                        })
                    }
                    await API.assignPayrollProcess({
                        projectId: this.itemToClose.projectId,
                        externalUserId: this.itemToClose.id,
                        timesheets: uniqueIds,
                        reportName: { nomina: reportName },
                        type: 'superintendent',
                    })
                } else {
                    if (userIndex != -1) {
                        const user = this.usersList[userIndex]
                        const existingNomina = user.nomina[reportName] || {}
                        const existingProjectsPMApproved =
                            existingNomina.projectsPMApproved || []
                        const projectsPMApproved = existingProjectsPMApproved.includes(
                            this.itemToClose.projectId
                        )
                            ? existingProjectsPMApproved
                            : [
                                  ...existingProjectsPMApproved,
                                  this.itemToClose.projectId,
                              ]
                        this.$set(user.nomina, reportName, {
                            ...existingNomina,
                            closed: true,
                            projectsPMApproved,
                        })
                        user.externalUsersData.forEach(timesheet => {
                            if (uniqueIds.includes(timesheet.id)) {
                                timesheet.nomina = reportName
                            }
                        })
                    }
                    await API.assignPayrollProcess({
                        projectId: this.itemToClose.projectId,
                        externalUserId: this.itemToClose.id,
                        timesheets: uniqueIds,
                        reportName: { nomina: reportName },
                        type: 'PM',
                    })
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.loading2 = false
                this.closeDialogPayroll()
            }
        },
        openAlertPayroll(item) {
            this.itemToClose = _.cloneDeep(item)
            this.closePayrollDialog = true
        },
        closeDialogPayroll() {
            this.closePayrollDialog = false
            this.itemToClose = {}
        },
        async openReport(item) {
            try {
                this.loading = false
                let reportName = ''
                if (this.filter == 'weekly') {
                    reportName = `Week ${this.weekFilter}`
                } else {
                    reportName = this.monthFilter
                }
                if (
                    item.payrolls[reportName] &&
                    item.payrolls[reportName].attachments &&
                    item.payrolls[reportName].attachments.length > 0
                ) {
                    let attachments = []
                    for (const doc of item.payrolls[reportName].attachments) {
                        const storageRef = storage().ref(
                            `${this.companyId}/projects/${item.projectId}/payrolls`
                        )
                        if (doc.newFile || doc.url) {
                            attachments.push(doc)
                            continue
                        }
                        const documentRef = storageRef.child(doc)
                        await documentRef
                            .getDownloadURL()
                            .then(response => {
                                attachments.push({
                                    name: doc,
                                    url: response,
                                })
                            })
                            .catch(() => {
                                attachments.push({
                                    name: doc,
                                    url: '',
                                })
                            })
                    }
                    for (const file of attachments) {
                        if (file.name.includes('.pdf')) {
                            file.pdfPreview = await loadPDFPreview(file.url)
                        }
                    }
                    item.payrolls[reportName].attachments = attachments
                } else {
                    item.payrolls[reportName].attachments = []
                }
                for (const attachment of item.payrolls[reportName]
                    .attachments) {
                    const isPDF = attachment.name.includes('.pdf')
                    if (isPDF) {
                        const dataURL = await loadPDFPreview(attachment.url)
                        const file = dataURLtoFile(dataURL, attachment.name)
                        attachment.firstPageURL = URL.createObjectURL(file)
                        attachment.isPDF = isPDF
                    }
                }
                await generateHTMLReport(item.payrolls[reportName])
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        getTimesheetHeaders(timesheet) {
            let timesheetHeaders = [
                {
                    text: 'Day',
                    value: 'date',
                    align: 'left',
                    sortable: false,
                    width: '130',
                },
                {
                    text: 'Role',
                    value: 'role',
                    align: 'center',
                    sortable: false,
                    width: '135',
                },
                {
                    text: 'Scope',
                    value: 'scope',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Project Location',
                    value: 'location',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Clock In',
                    value: 'clockIn',
                    align: 'center',
                    sortable: false,
                    width: '105',
                },
                {
                    text: 'Clock Out',
                    value: 'clockOut',
                    align: 'center',
                    sortable: false,
                    width: '105',
                },
                {
                    text: 'Total time',
                    value: 'totalTime',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'Status',
                    value: 'status',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'Notes',
                    value: 'notes',
                    align: 'center',
                    sortable: false,
                },
            ]
            if (this.getStatus(timesheet) == 'Pending') {
                timesheetHeaders.push({
                    text: 'Actions',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: '90',
                })
            }
            return timesheetHeaders
        },
        async createTimesheet(timesheet) {
            try {
                this.loading2 = true
                this.dialogCreateTimesheet = true
                this.selectedTimesheet = _.cloneDeep(timesheet)
                const project = this.projects.find(
                    obj => obj.id === timesheet.projectId
                )
                if (project != undefined) {
                    this.projectLocations = await API.getProjectLocations({
                        projectId: timesheet.projectId,
                    })
                    for (const quote of project.quotes) {
                        const response = await API.getCosts(quote.split('/')[0])
                        response.forEach(item => {
                            this.$set(
                                this.itemsScopesTimesheet,
                                item.reference,
                                {
                                    cost: {
                                        id: item.id,
                                        reference: item.reference,
                                        selected: true,
                                    },
                                    quote: {
                                        id: quote.split('/')[0],
                                        name: project.name,
                                    },
                                }
                            )
                        })
                    }
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.loading2 = false
            }
        },
        closeCreateTimesheet() {
            this.selectedTimesheet = {}
            this.dialogCreateTimesheet = false
            this.scopeTimesheet = null
            this.itemsScopesTimesheet = {}
            this.scopeValueTimesheet = null
            this.selectedDateTimesheet = null
            this.timesheetDate = null
            this.valid3 = false
            this.clockInTimesheet = { hh: '', mm: '', ss: '', a: '' }
            this.clockOutTimesheet = { hh: '', mm: '', ss: '', a: '' }
            this.timesheetNotes = ''
            this.projectLocations = []
            this.projectLocation = null
        },
        async saveTimesheet() {
            try {
                this.loading2 = true
                const locationInfo =
                    this.projectLocation &&
                    typeof this.projectLocation === 'object'
                        ? this.projectLocation
                        : this.projectLocations.find(
                              location =>
                                  location.id === this.projectLocation ||
                                  location.name === this.projectLocation
                          )
                if (!locationInfo) {
                    return null
                }
                const timesheet = {
                    externalUserId: this.selectedTimesheet.id,
                    clockIn: this.convertToTimestamp(
                        this.timesheetDate,
                        this.clockInTimesheet
                    ),
                    clockInLocation: locationInfo.location,
                    clockOut: this.convertToTimestamp(
                        this.timesheetDate,
                        this.clockOutTimesheet
                    ),
                    clockOutLocation: locationInfo.location,
                    date: String(this.timesheetDate),
                    projectId: this.selectedTimesheet.projectId,
                    projectLocation: locationInfo,
                    selectedCost: this.scopeValueTimesheet,
                    ...(this.timesheetNotes != ''
                        ? { notes: this.timesheetNotes }
                        : {}),
                }
                const response = await API.createTimesheet(timesheet)
                if (response) {
                    const userRecordIndex = this.usersList.findIndex(
                        user =>
                            user.projectId ===
                                this.selectedTimesheet.projectId &&
                            user.id === this.selectedTimesheet.id
                    )
                    if (userRecordIndex != -1) {
                        const userRecord = this.usersList[userRecordIndex]
                        this.$set(
                            userRecord.externalUsersData,
                            userRecord.externalUsersData.length,
                            {
                                role: this.selectedTimesheet.role,
                                externalUserId: this.selectedTimesheet.id,
                                name: this.selectedTimesheet.name,
                                ...response,
                            }
                        )
                        this.usersList = [...this.usersList]
                    }
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.loading2 = false
                this.closeCreateTimesheet()
            }
        },
        isDateInWeek(date) {
            const parts = this.parseDateParts(date)
            if (!parts) return false
            const year = parseInt(this.yearFilter, 10)
            // Allow week 1 spill from previous calendar year
            if (parts.year !== year && !(parts.year === year - 1)) {
                return false
            }
            const selectedWeek = parseInt(this.weekFilter, 10)
            const weekOfDate = this.getWeekNumberMondayStart(date)
            return selectedWeek === weekOfDate
        },
        isDateInMonth(date) {
            const parts = this.parseDateParts(date)
            if (!parts) return false
            if (parts.year !== parseInt(this.yearFilter, 10)) return false
            const selectedMonth = this.monthFilter.toLowerCase()
            const monthOfDate = moment()
                .month(parts.month - 1)
                .format('MMMM')
                .toLowerCase()
            return selectedMonth === monthOfDate
        },
        getWeekNumberMondayStart(date) {
            const parts = this.parseDateParts(date)
            const d = parts
                ? new Date(parts.year, parts.month - 1, parts.day)
                : new Date(date + 'T00:00:00')
            d.setHours(0, 0, 0, 0)
            const year = parseInt(this.yearFilter, 10) || d.getFullYear()
            const mondayOffset = (d.getDay() + 6) % 7
            const currentMonday = new Date(d)
            currentMonday.setDate(d.getDate() - mondayOffset)
            const firstDayOfYear = new Date(year, 0, 1).getDay()
            const firstMondayOffset =
                firstDayOfYear === 0 ? 1 : 1 - firstDayOfYear
            const firstMonday = new Date(year, 0, 1 + firstMondayOffset)
            return (
                1 + Math.floor((currentMonday - firstMonday) / (7 * 86400000))
            )
        },
        updateDate(date) {
            this.timesheetDate = date
            this.menu = false
        },
        updateScope() {
            this.scopeValueTimesheet = this.itemsScopesTimesheet[
                this.scopeTimesheet
            ]
        },
        setHourlyPrice(item) {
            const totalHours = this.getTotalHours(item)
            const overtimeHours = this.getOvertimeHours(item)
            let totalPrice = 0
            if (
                item.payrolls?.[
                    this.filter === 'weekly'
                        ? `Week ${this.weekFilter}`
                        : this.monthFilter
                ]?.hourlyPrice
            ) {
                const hourlyPrice = Number(
                    item.payrolls[
                        this.filter === 'weekly'
                            ? `Week ${this.weekFilter}`
                            : this.monthFilter
                    ].hourlyPrice
                )
                if (!isNaN(hourlyPrice) && hourlyPrice != 0) {
                    totalPrice = (
                        hourlyPrice *
                        (totalHours - overtimeHours)
                    ).toFixed(2)
                } else {
                    totalPrice = '-'
                }
            } else if (item.hourlyPrice) {
                if (
                    !isNaN(Number(item.hourlyPrice)) &&
                    Number(item.hourlyPrice) != 0
                ) {
                    totalPrice = (
                        Number(item.hourlyPrice) *
                        (totalHours - overtimeHours)
                    ).toFixed(2)
                } else {
                    totalPrice = '-'
                }
            } else {
                totalPrice = '-'
            }
            return totalPrice
        },
        setOvertimePrice(item) {
            const overtimeHours = this.getOvertimeHours(item)
            let totalPrice = 0
            if (
                item.payrolls?.[
                    this.filter === 'weekly'
                        ? `Week ${this.weekFilter}`
                        : this.monthFilter
                ]?.hourlyPrice
            ) {
                const hourlyPrice = Number(
                    item.payrolls[
                        this.filter === 'weekly'
                            ? `Week ${this.weekFilter}`
                            : this.monthFilter
                    ].hourlyPrice
                )
                if (!isNaN(hourlyPrice) && hourlyPrice != 0) {
                    totalPrice = (hourlyPrice * 1.015 * overtimeHours).toFixed(
                        2
                    )
                } else {
                    totalPrice = '-'
                }
            } else if (item.hourlyPrice) {
                if (
                    !isNaN(Number(item.hourlyPrice)) &&
                    Number(item.hourlyPrice) != 0
                ) {
                    totalPrice = (
                        Number(item.hourlyPrice) *
                        1.015 *
                        overtimeHours
                    ).toFixed(2)
                } else {
                    totalPrice = '-'
                }
            } else {
                totalPrice = '-'
            }
            return totalPrice
        },
        setOtherCosts(item) {
            let totalOtherCosts = 0
            item.externalUsersData.forEach(timesheet => {
                if (timesheet.otherCosts) {
                    totalOtherCosts += parseFloat(timesheet.otherCosts)
                }
            })
            if (item.lastExternalUsersData) {
                item.lastExternalUsersData.forEach(timesheet => {
                    if (timesheet.otherCosts) {
                        totalOtherCosts += parseFloat(timesheet.otherCosts)
                    }
                })
            }

            return totalOtherCosts.toFixed(2)
        },
        async openFile(file) {
            try {
                this.loading2 = true
                const localFile = this.temporalAttachments.find(
                    f => f.name == file
                )

                if (localFile) {
                    const url = URL.createObjectURL(localFile)
                    window.open(url, '_blank')
                } else {
                    const savedFile = this.files.find(f => f.name == file)
                    if (saveFile) {
                        window.open(savedFile.url, '_blank')
                    }
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        async deleteFileRecord(file) {
            try {
                this.loading2 = true
                const checkFile = this.files.find(f => f.name == file)
                if (checkFile.newFile) {
                    this.temporalAttachments = this.temporalAttachments.filter(
                        f => f.name != file
                    )
                    this.files = this.files.filter(f => f.name != file)
                } else {
                    if (checkFile.url) {
                        this.deleteAttachments.push({ name: file, exist: true })
                    } else {
                        this.deleteAttachments.push({
                            name: file,
                            exist: false,
                        })
                    }
                    this.files = this.files.filter(f => f.name != file)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        setTotal(item) {
            const hourlyPrice = this.setHourlyPrice(item)
            const overtimePrice = this.setOvertimePrice(item)
            const otherCosts = this.setOtherCosts(item)
            let total = 0
            total =
                Number(hourlyPrice) + Number(overtimePrice) + Number(otherCosts)
            return total
        },
        parseTime({ hh, mm, ss, a }) {
            if (!hh || !mm || !ss || !a) return null
            let h = parseInt(hh)
            if (a.toLowerCase() === 'pm' && h < 12) h += 12
            if (a.toLowerCase() === 'am' && h === 12) h = 0
            return h * 60 + parseInt(mm)
        },
        formatTime2(totalMinutes) {
            let h = Math.floor(totalMinutes / 60)
            let m = totalMinutes % 60
            let a = h >= 12 ? 'pm' : 'am'
            h = h % 12 || 12
            return {
                hh: h.toString().padStart(2, '0'),
                mm: m.toString().padStart(2, '0'),
                ss: '00',
                a,
            }
        },
        calculateRoundedDiff() {
            const start = this.parseTime(this.clockInSelected)
            const end = this.parseTime(this.clockOutSelected)
            if (start == null || end == null || end <= start) return 0
            const raw = (end - start) / 60
            return Math.ceil(raw * 2) / 2
        },
        updateClockOut(hours) {
            const start = this.parseTime(this.clockInSelected)
            if (start == null) return
            const newEnd = start + hours * 60
            this.clockOutSelected = this.formatTime2(newEnd)
        },
    },
}
</script>
<style>
.v-menu__content {
    z-index: 10000 !important;
}

/* Wrapper: limita altura y permite scroll del cuerpo de la tabla */
.nomina-table-wrapper {
    max-height: calc(100vh - 180px);
    overflow: auto;
    position: relative;
}
.nomina-table-wrapper .nomina-main-table .v-data-table__wrapper {
    position: relative;
    z-index: 2;
}

/* Barra superior y encabezados van juntos en el mismo scroll (sin sticky) */
.nomina-table-wrapper .nomina-main-table .v-data-table__wrapper table {
    border-collapse: collapse;
}
.nomina-table-wrapper .nomina-main-table .v-data-table__wrapper table thead th {
    background-color: #eeeeee !important;
}

/* tbody con z-index menor */
.nomina-table-wrapper .nomina-main-table .v-data-table__wrapper table tbody {
    position: relative;
    z-index: 0;
}

/* Fila expandida y tablas interiores: debajo del header */
.nomina-table-wrapper .nomina-main-table .nomina-expanded-row-content {
    position: relative;
    z-index: 0;
}
.nomina-table-wrapper
    .nomina-main-table
    .nomina-expanded-row-content
    .nomina-inner-table-wrapper,
.nomina-table-wrapper
    .nomina-main-table
    .nomina-expanded-row-content
    .nomina-inner-table-wrapper
    .v-data-table,
.nomina-table-wrapper
    .nomina-main-table
    .nomina-expanded-row-content
    .nomina-inner-table-wrapper
    .v-data-table
    .v-data-table__wrapper {
    position: relative;
    z-index: 0;
}

.custom-dialog {
    overflow: visible !important;
}
.preview_pdf {
    display: inline-block;
    max-height: 150px;
    max-width: 150px;
}
.custom-timepicker .active {
    background-color: #1976d2 !important;
    color: white !important;
}
</style>
